const leaflets = {
    "crai": {
        "config": {
            "primary-color": "rgb(0, 102, 58)",
            "secondary-color": "rgb(229, 50, 18)",
            "tertiary-color": "rgb(99, 44, 56)",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "clientIcon": require("assets/images/logo-crai.png"),
            "serverPath": "regina.volantinointerattivo.net/",
            "pdfPath": "/media/pdf/volantino.pdf",
            "shareFlyerTitle": "Dai uno sguardo al nuovo volantino di CRAI Regina!",
            "shareFlyerURL": "https://regina.volantinointerattivo.net?v=343",
            "shareProductSentence": "Guarda questa fantastica offerta!",
            "ogTitleMeta": "CRAI Regina | Volantino Interattivo",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo volantino. Offerte valide dal 4/03 al 13/03",
            "ogImageMeta": "https://regina.volantinointerattivo.net/media/images/crai_05_fb.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": true,
            "ga_tracking_id": "UA-152069090-47",
            "release_id": "1",
            "send_grocery_list_to_market": false,
            "grocery_list_min_value": 20,
            "client_id": 33,
            "signboard_id": 56,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": false,
            "category_banner": "/media/images/banner_05.jpg",
            "category_banner_mobile": "/media/images/banner_05_mobile.jpg",
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "type": "leaflet",
            "product_banner": "",
            "href_banner": "",
            "internal_banner_click": false,
            "external_banner_click": false,
            "version": 343
        },
        "leaflet": {
            "name": "CRAI AP05",
            "code": "343",
            "id_campaign": "343",
            "index": {
                "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/Indice-crai_rP0S3wf.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 25.03164496506007,
                            "left": 11.625678930389743,
                            "width": 77.31189376316713,
                            "height": 5.653864828388345
                        }
                    },
                    {
                        "page": 4,
                        "blueprint": {
                            "top": 30.920800320792164,
                            "left": 11.46182353844803,
                            "width": 77.31189376316713,
                            "height": 6.340436858885937
                        }
                    },
                    {
                        "page": 6,
                        "blueprint": {
                            "top": 37.36172255122642,
                            "left": 11.446708764922748,
                            "width": 77.31189376316713,
                            "height": 6.340436858885937
                        }
                    },
                    {
                        "page": 9,
                        "blueprint": {
                            "top": 43.49384534416382,
                            "left": 11.590566570839183,
                            "width": 77.31189376316713,
                            "height": 6.340436858885937
                        }
                    },
                    {
                        "page": 11,
                        "blueprint": {
                            "top": 50.0408357525331,
                            "left": 12.073855282215588,
                            "width": 77.31189376316713,
                            "height": 6.340436858885937
                        }
                    },
                    {
                        "page": 12,
                        "blueprint": {
                            "top": 56.241410012038514,
                            "left": 12.134815001755614,
                            "width": 77.31189376316713,
                            "height": 6.340436858885937
                        }
                    },
                    {
                        "page": 14,
                        "blueprint": {
                            "top": 62.82707153124372,
                            "left": 12.171888715765446,
                            "width": 77.31189376316713,
                            "height": 6.340436858885937
                        }
                    },
                    {
                        "page": 16,
                        "blueprint": {
                            "top": 68.94978922787293,
                            "left": 12.013883097787916,
                            "width": 77.31189376316713,
                            "height": 6.340436858885937
                        }
                    },
                    {
                        "page": -1,
                        "type": "url",
                        "url": "https://volantinointerattivo.net",
                        "target": "_blank",
                        "blueprint": {
                            "top": 5.917774086378737,
                            "left": 63.76162790697674,
                            "width": 27.563953488372086,
                            "height": 6.484634551495015
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Igiene Casa",
                    "subcategories": [
                        "Extra",
                        "Stoviglie",
                        "Bucato"
                    ]
                },
                {
                    "category_name": "Self Service",
                    "subcategories": [
                        "Pasta",
                        "Latte",
                        "Formaggi",
                        "Ittico",
                        "Vegetali",
                        "Yogurt",
                        "Salumi",
                        "Snack"
                    ]
                },
                {
                    "category_name": "Surgelati",
                    "subcategories": [
                        "Panati",
                        "Verdure",
                        "Gelati",
                        "Carne",
                        "Ittico",
                        "Preparati"
                    ]
                },
                {
                    "category_name": "Gastronomia",
                    "subcategories": [
                        "Formaggi",
                        "Salumi"
                    ]
                },
                {
                    "category_name": "Alimentari",
                    "subcategories": [
                        "Rossi",
                        "Dispensa",
                        "Snack Dolci",
                        "Olio",
                        "Snack Salati",
                        "Colazione"
                    ]
                },
                {
                    "category_name": "Igiene Persona",
                    "subcategories": [
                        "Corpo",
                        "Orale",
                        "Intima"
                    ]
                },
                {
                    "category_name": "Prima infanzia",
                    "subcategories": [
                        "Puericultura"
                    ]
                },
                {
                    "category_name": "Bevande",
                    "subcategories": [
                        "Bibite",
                        "Birre",
                        "Vini e Spumanti",
                        "Succhi",
                        "Acqua",
                        "Liquori"
                    ]
                },
                {
                    "category_name": "Macelleria",
                    "subcategories": [
                        "Bovino",
                        "Altro",
                        "Suino"
                    ]
                },
                {
                    "category_name": "Ortofrutta",
                    "subcategories": [
                        "Frutta",
                        "Verdura"
                    ]
                },
                {
                    "category_name": "Casa e Cucina",
                    "subcategories": [
                        "Altro"
                    ]
                },
                {
                    "category_name": "Pet",
                    "subcategories": [
                        "Food"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_1_InO3Bfg.jpg",
                    "products": [
                        {
                            "item_id": "cstm92561805",
                            "field1": "liquido lavatrice",
                            "field2": "ace",
                            "field3": "vari tipi 25 lavaggi x3",
                            "field4": "",
                            "description": "liquido lavatrice ace vari tipi 25 lavaggi x3",
                            "grammage": null,
                            "price": "5.98",
                            "price_label": "€ 5,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 18.383301009667445,
                                "left": 30.835608297619117,
                                "width": 37.54075931726053,
                                "height": 37.49926367691369
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/1_3nsWlg8.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_aEYC57m_uRAZKWn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://ace.it/"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99017431",
                            "field1": "pasta di semola",
                            "field2": "la molisana",
                            "field3": "varie trafile",
                            "field4": "gr.500",
                            "description": "pasta di semola la molisana varie trafile gr.500",
                            "grammage": null,
                            "price": "0.58",
                            "price_label": "€ 0,58",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 55.42575729543065,
                                "left": 30.65110995837322,
                                "width": 37.846827133479216,
                                "height": 31.52953181139884
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/2_QhCFe1d.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/3_vN358ix.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_xecGtWf_XD44uzh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.lamolisana.it/le-classiche/"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm12098663",
                            "field1": "latte p.s.",
                            "field2": "granarolo",
                            "field3": "brick lt.1",
                            "field4": "",
                            "description": "latte p.s. granarolo brick lt.1",
                            "grammage": null,
                            "price": "0.63",
                            "price_label": "€ 0,63",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 39.819214735302424,
                                "left": 67.7152332207148,
                                "width": 28.946086036157467,
                                "height": 43.797265182120974
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/4_PnDA69a.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_WRFUwG6_MQlEJWQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Latte granarolo",
                                        "testo": "Da oltre 50 anni Granarolo lavora il latte per ottenere prodotti buoni e controllati, come il nostro Latte Parzialmente Scremato UHT a lunga conservazione. Nei nostri stabilimenti utilizziamo trattamenti termici sicuri e confezionamenti moderni che permettono di rispettarne la qualità e di garantire, alla confezione integra, una durata prolungata. (Fonte: granarolo.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/images/Latte_UHT_Parzialmente_Scremato_Granarolo_1L.jpg"
                                        ]
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_2_veyWpwt.jpg",
                    "products": [
                        {
                            "item_id": "cstm17271401",
                            "field1": "Bocconcini di pollo",
                            "field2": "aia",
                            "field3": "semplicemente panati",
                            "field4": "gr.280",
                            "description": "Bocconcini di pollo aia semplicemente panati gr.280",
                            "grammage": null,
                            "price": "1.95",
                            "price_label": "€ 1,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 15.29026275949577,
                                "left": 4.65748659630573,
                                "width": 18.113301149864945,
                                "height": 32.0412605097235
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/5_hL7iRLf.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_ycLDbb1_ZBtJJ0V.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42196899",
                            "field1": "L'abc della merenda",
                            "field2": "parmareggio",
                            "field3": "plumcake",
                            "field4": "",
                            "description": "L'abc della merenda parmareggio plumcake",
                            "grammage": null,
                            "price": "0.70",
                            "price_label": "€ 0,70",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 15.29026275949577,
                                "left": 22.77078774617068,
                                "width": 18.113301149864945,
                                "height": 32.0412605097235
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/6_Yu9nGH4.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_ajms2QD_bCLkMFp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.parmareggio.it/abc-prodotto/57"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm87638576",
                            "field1": "we love rustiche",
                            "field2": "pizzolli",
                            "field3": "gr.750",
                            "field4": "",
                            "description": "we love rustiche pizzolli gr.750",
                            "grammage": null,
                            "price": "1.18",
                            "price_label": "€ 1,18",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 47.33152326921927,
                                "left": 4.65748659630573,
                                "width": 36.22660229972989,
                                "height": 22.402834616515293
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/12_hY3wyMt.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_QGONmTV_EyfNjKJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm01805350",
                            "field1": "cornetto classico",
                            "field2": "algida",
                            "field3": "x12",
                            "field4": "",
                            "description": "cornetto classico algida x12",
                            "grammage": null,
                            "price": "3.98",
                            "price_label": "€ 3,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 69.73435788573455,
                                "left": 4.65748659630573,
                                "width": 36.22660229972989,
                                "height": 25.659059725466573
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/16_8kUq4OS.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_xW9GIFj_NPfqwfT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Cornetto_010s.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm72109193",
                            "field1": "tonno",
                            "field2": "marevivo",
                            "field3": "in olio di girasole",
                            "field4": "gr.80x3",
                            "description": "tonno marevivo in olio di girasole gr.80x3",
                            "grammage": null,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 74.68382205468261,
                                "left": 40.88408889603563,
                                "width": 36.22660229972989,
                                "height": 20.709595556518515
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/17_PpgW20x.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_ctFbcN5_NvUhBtM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm38456558",
                            "field1": "broccoli rosette",
                            "field2": "orogel",
                            "field3": "gr.400",
                            "field4": "",
                            "description": "broccoli rosette orogel gr.400",
                            "grammage": null,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 47.07102440192797,
                                "left": 40.88408889603563,
                                "width": 18.11329781096143,
                                "height": 27.612797652754644
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/13_9COtlPT.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_6vZDazO_0UUsUNA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm02357699",
                            "field1": "lasagne all'uovo",
                            "field2": "emiliane barilla",
                            "field3": "",
                            "field4": "",
                            "description": "lasagne all'uovo emiliane barilla",
                            "grammage": null,
                            "price": "1.45",
                            "price_label": "€ 1,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 47.07102440192797,
                                "left": 58.997386706997055,
                                "width": 18.23486061012719,
                                "height": 27.612797652754644
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/14_KKGiNuu.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_o4MlTJp_koGv33i.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17863475",
                            "field1": "insalata capricciosa",
                            "field2": "vogliazzi",
                            "field3": "gr.150",
                            "field4": "",
                            "description": "insalata capricciosa vogliazzi gr.150",
                            "grammage": null,
                            "price": "0.58",
                            "price_label": "€ 0,58",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 31.180643580711877,
                                "left": 58.997386706997055,
                                "width": 18.23486061012719,
                                "height": 15.890380821216104
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/11_CsQ01Gf.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_Cm4YnYh_Sh4FsWa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88870251",
                            "field1": "inalata russa",
                            "field2": "vogliazzi",
                            "field3": "gr.150",
                            "field4": "",
                            "description": "inalata russa vogliazzi gr.150",
                            "grammage": null,
                            "price": "0.48",
                            "price_label": "€ 0,48",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 31.180643580711877,
                                "left": 40.76251941906284,
                                "width": 18.234867287934218,
                                "height": 15.890380821216104
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/10_IM6N5jt.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_7PeMufr_90kc1rG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm75827796",
                            "field1": "yogurt A.Q.",
                            "field2": "granarolo",
                            "field3": "vari gusti",
                            "field4": "gr.125x2",
                            "description": "yogurt A.Q. granarolo vari gusti gr.125x2",
                            "grammage": null,
                            "price": "0.55",
                            "price_label": "€ 0,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 15.420508615744799,
                                "left": 40.76251941906284,
                                "width": 36.59130405284122,
                                "height": 15.760134964967078
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/7_wSqVjAT.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/8_MtUM77i.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_ob5Ig01_rlFnsAK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm14772792",
                            "field1": "wustel di suino",
                            "field2": "wuberone wuber",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "wustel di suino wuberone wuber gr.250",
                            "grammage": null,
                            "price": "1.48",
                            "price_label": "€ 1,48",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 15.420508615744799,
                                "left": 77.35382347190406,
                                "width": 18.11329781096143,
                                "height": 26.31031047109143
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/9_Xiryfk7.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_4PM13dt_3IN4AuD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm44288660",
                            "field1": "formaggio di capra di puglia",
                            "field2": "il carro",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "formaggio di capra di puglia il carro all'etto",
                            "grammage": null,
                            "price": "1.05",
                            "price_label": "€ 1,05 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 41.73081908683623,
                                "left": 77.35382347190406,
                                "width": 18.11329781096143,
                                "height": 26.04980444900689
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/15_63IhhDd.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_jwsXXIM_AtvlXub.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm00088828",
                            "field1": "pomodori pelati",
                            "field2": "lina",
                            "field3": "gr.400",
                            "field4": "",
                            "description": "pomodori pelati lina gr.400",
                            "grammage": null,
                            "price": "0.40",
                            "price_label": "€ 0,40",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 67.7806235358431,
                                "left": 77.35382347190406,
                                "width": 18.11329781096143,
                                "height": 26.961557639319658
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/18_10KK1xm.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_taoaZae_PU4FIvN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_3_tyr4mga.jpg",
                    "products": [
                        {
                            "item_id": "cstm81749021",
                            "field1": "maionese classica",
                            "field2": "calvè",
                            "field3": "gr.500",
                            "field4": "",
                            "description": "maionese classica calvè gr.500",
                            "grammage": null,
                            "price": "1.35",
                            "price_label": "€ 1,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 15.55076162678706,
                                "left": 4.535920458236461,
                                "width": 18.234867287934218,
                                "height": 31.650515786183185
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/19_BYsXQAw.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_AGb6qB0_r35zbp6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Calve_on_air.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23279304",
                            "field1": "lievito",
                            "field2": "paneangeli",
                            "field3": "x10",
                            "field4": "",
                            "description": "lievito paneangeli x10",
                            "grammage": null,
                            "price": "2.85",
                            "price_label": "€ 2,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 15.55076162678706,
                                "left": 22.77078774617068,
                                "width": 17.870165534822892,
                                "height": 15.760134964967078
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/20_qRNr8dF.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_yHcoPOR_UvGYQSD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm75810251",
                            "field1": "miele di fiori",
                            "field2": "",
                            "field3": "vaso kg.1",
                            "field4": "",
                            "description": "miele di fiori vaso kg.1",
                            "grammage": null,
                            "price": "4.70",
                            "price_label": "€ 4,70",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 31.310896591754137,
                                "left": 22.77078774617068,
                                "width": 17.870165534822892,
                                "height": 15.890380821216104
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/21_mxS5fec.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_onQY8h7_1mCHxzl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm65783873",
                            "field1": "biscotti",
                            "field2": "ringo pavesi",
                            "field3": "vari tipi tubo",
                            "field4": "gr.165",
                            "description": "biscotti ringo pavesi vari tipi tubo gr.165",
                            "grammage": null,
                            "price": "0.70",
                            "price_label": "€ 0,70",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 47.20127741297024,
                                "left": 4.900618872444269,
                                "width": 35.7403344085493,
                                "height": 23.705325375575132
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/25_JeeeG8Q.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_Tuqon4U_3Tke6pT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Ringo__Sempre_al_top.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm24003475",
                            "field1": "shampoo/ balsamo",
                            "field2": "ultra dolce",
                            "field3": "vari tipi",
                            "field4": "",
                            "description": "shampoo/ balsamo ultra dolce vari tipi",
                            "grammage": null,
                            "price": "1.50",
                            "price_label": "€ 1,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Shampoo",
                                "Balsamo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 70.90660278854536,
                                "left": 4.900618872444269,
                                "width": 17.99173167289216,
                                "height": 24.356576121199982
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/30_tBpsnkG.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/31_o0v5YEA.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_JEF5o8N_dXuMail.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60279846",
                            "field1": "bagnoschiuma",
                            "field2": "vidal",
                            "field3": "vari tipi",
                            "field4": "ml.500",
                            "description": "bagnoschiuma vidal vari tipi ml.500",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 70.90660278854536,
                                "left": 22.89235054533643,
                                "width": 17.870172212629925,
                                "height": 24.356576121199982
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/32_SBlrSsd.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_BpH3gNl_ncXoeT6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm11966340",
                            "field1": "pannolini sole&luna",
                            "field2": "pampers",
                            "field3": "varie misure",
                            "field4": "",
                            "description": "pannolini sole&luna pampers varie misure",
                            "grammage": null,
                            "price": "5.80",
                            "price_label": "€ 5,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Prima infanzia",
                            "subcategory": "Puericultura",
                            "blueprint": {
                                "top": 70.90660278854536,
                                "left": 40.76252275796636,
                                "width": 36.34817177670268,
                                "height": 24.356576121199982
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/33_gELTxZo.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_f4AMrdz_1OMUX71.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm62265910",
                            "field1": "bitter",
                            "field2": "ben's",
                            "field3": "bianco/ rosso",
                            "field4": "cl.10x6",
                            "description": "bitter ben's bianco/ rosso cl.10x6",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Rosso"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 46.81053268942992,
                                "left": 40.76252275796636,
                                "width": 18.234867287934218,
                                "height": 24.096070099115448
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/26_bzwuaec.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/27_sdDO0Od.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_9TZTysa_4pgJw7M.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm96127514",
                            "field1": "integratore",
                            "field2": "energade",
                            "field3": "vari gusti",
                            "field4": "cl.50",
                            "description": "integratore energade vari gusti cl.50",
                            "grammage": null,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 46.81053268942992,
                                "left": 58.99739004590057,
                                "width": 18.234867287934218,
                                "height": 24.096070099115448
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/28_CJYA9QD.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_lHBfDRX_WDQz4ao.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm10627047",
                            "field1": "nutella",
                            "field2": "ferrero",
                            "field3": "gr.725",
                            "field4": "",
                            "description": "nutella ferrero gr.725",
                            "grammage": null,
                            "price": "4.95",
                            "price_label": "€ 4,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 15.42051219314142,
                                "left": 40.88409223493914,
                                "width": 18.11329781096143,
                                "height": 31.390020496288507
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/22_S1GGhCR.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_XMoMguo_zaKLKYd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Nutella.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm01751255",
                            "field1": "biscoro",
                            "field2": "di leo",
                            "field3": "classico/ integrale",
                            "field4": "gr.800",
                            "description": "biscoro di leo classico/ integrale gr.800",
                            "grammage": null,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classico",
                                "Integrale"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 15.42051219314142,
                                "left": 58.99739004590057,
                                "width": 17.99174168960271,
                                "height": 31.390020496288507
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/23_BSsTbfd.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_IEgsPPJ_Tb4Fx5p.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23702221",
                            "field1": "birra",
                            "field2": "moretti",
                            "field3": "cl.66",
                            "field4": "",
                            "description": "birra moretti cl.66",
                            "grammage": null,
                            "price": "0.80",
                            "price_label": "€ 0,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 15.42051219314142,
                                "left": 76.98913173550328,
                                "width": 18.599555685431483,
                                "height": 31.390020496288507
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/24_2Yyja9N.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_8X4zlvB_D0L8xSG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm41431800",
                            "field1": "vino",
                            "field2": "tavernello",
                            "field3": "Bianco/ rosso/ rosato",
                            "field4": "brick lt.1",
                            "description": "vino tavernello Bianco/ rosso/ rosato brick lt.1",
                            "grammage": null,
                            "price": "1.20",
                            "price_label": "€ 1,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Rosso",
                                "Rosato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 46.81053268942992,
                                "left": 76.98913173550328,
                                "width": 18.599555685431483,
                                "height": 24.35656896640674
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/29_wrxLq5t.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_oZGkvkV_HdR7ghJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm18024825",
                            "field1": "detergente",
                            "field2": "fabuloso",
                            "field3": "varie profumazioni",
                            "field4": "lt.1",
                            "description": "detergente fabuloso varie profumazioni lt.1",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 71.16710165583666,
                                "left": 76.98913173550328,
                                "width": 18.599555685431483,
                                "height": 24.356576121199982
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/34_8Y2cuSk.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_dnfGZg6_PKBAabj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_4_AhPKOle.jpg",
                    "products": [
                        {
                            "item_id": "cstm76009236",
                            "field1": "girello di vitellone",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "girello di vitellone al kg",
                            "grammage": null,
                            "price": "9.20",
                            "price_label": "€ 9,20 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 12.815528886323428,
                                "left": 4.984198305225998,
                                "width": 18.599555685431483,
                                "height": 19.14661487365894
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/1_NZrNWfO_bsZXfU2.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_1SEt5Fc_FSvgK8Z.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm94433932",
                            "field1": "muscolo di vitellone",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "muscolo di vitellone al kg",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 12.815528886323428,
                                "left": 23.583753990657478,
                                "width": 17.99174502850622,
                                "height": 19.14661487365894
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/2_ShoFGeW_7ySOkHX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_mriNHwc_Kl394GM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80094830",
                            "field1": "macinato misto",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "macinato misto al kg",
                            "grammage": null,
                            "price": "4.90",
                            "price_label": "€ 4,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 12.815528886323428,
                                "left": 41.5754990191637,
                                "width": 18.113287794250887,
                                "height": 19.14661487365894
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/3_1h7kjGq_mgzK4QB.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_oL5mab2_fj4EZ7m.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49385790",
                            "field1": "spiedini di suino",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "spiedini di suino al kg",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 12.815528886323428,
                                "left": 59.68878681341459,
                                "width": 17.74861943017471,
                                "height": 19.14661487365894
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/4_IJjtvcM_NbtoSxj.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_YUa9STw_8ohsn9L.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35283061",
                            "field1": "prosciutto di suino a fette",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "prosciutto di suino a fette al kg",
                            "grammage": null,
                            "price": "3.90",
                            "price_label": "€ 3,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 12.815528886323428,
                                "left": 77.43740624358931,
                                "width": 18.59954566872094,
                                "height": 19.14661487365894
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/5_9ZXDy1e_pG5isLQ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_NL8yCsG_FVawkOt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm02507832",
                            "field1": "hamburger",
                            "field2": "martini",
                            "field3": "pollo/ suino x2",
                            "field4": "",
                            "description": "hamburger martini pollo/ suino x2",
                            "grammage": null,
                            "price": "1.65",
                            "price_label": "€ 1,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pollo",
                                "Suino"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Carne",
                            "blueprint": {
                                "top": 31.962143759982368,
                                "left": 77.43740624358931,
                                "width": 18.59954566872094,
                                "height": 17.19286800287932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/10_MOkZPyI_w2SqWoA.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_GVvc0Q1_CtMcoMA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm53559900",
                            "field1": "cordon bleu si pollo",
                            "field2": "martini",
                            "field3": "gr.270",
                            "field4": "",
                            "description": "cordon bleu si pollo martini gr.270",
                            "grammage": null,
                            "price": "1.75",
                            "price_label": "€ 1,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 31.962143759982368,
                                "left": 59.567224014248836,
                                "width": 17.870182229340468,
                                "height": 17.19286800287932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/9_vXmGHYU_Te6htO4.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_MiDikgo_dPBQ17a.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm25724968",
                            "field1": "ortaiola con spinaci",
                            "field2": "amadori",
                            "field3": "gr.220",
                            "field4": "",
                            "description": "ortaiola con spinaci amadori gr.220",
                            "grammage": null,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 31.962143759982368,
                                "left": 41.69707517394352,
                                "width": 17.87014884030532,
                                "height": 17.19286800287932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/8_gqZKSn2_UR8TW3j.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_nZd4ddh_8nvCpmm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm57682396",
                            "field1": "bon roll di tacchino",
                            "field2": "aia",
                            "field3": "gr.750",
                            "field4": "",
                            "description": "bon roll di tacchino aia gr.750",
                            "grammage": null,
                            "price": "4.80",
                            "price_label": "€ 4,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Carne",
                            "blueprint": {
                                "top": 31.962143759982368,
                                "left": 23.705323467630265,
                                "width": 17.991751706313252,
                                "height": 17.19286800287932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/7_yMJa5J2_9F5GWwf.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_BF36ept_yqP12I7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73374138",
                            "field1": "fesa di tacchino fette sottili",
                            "field2": "crai",
                            "field3": "al kg",
                            "field4": "",
                            "description": "fesa di tacchino fette sottili crai al kg",
                            "grammage": null,
                            "price": "9.50",
                            "price_label": "€ 9,50 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Carne",
                            "blueprint": {
                                "top": 31.962143759982368,
                                "left": 4.376380970493709,
                                "width": 19.328942497136556,
                                "height": 17.19286800287932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/6_9svz1S4_rKYOzFb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_671GaXa_z700o2M.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm78952089",
                            "field1": "mele golden",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "mele golden al kg",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 58.27244707628055,
                                "left": 3.9280897678901114,
                                "width": 24.313157496880127,
                                "height": 19.276858941209657
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/11_afihiCw_xV0cXaU.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_3z20hLF_wRKNbK6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm11244229",
                            "field1": "arance da tavola",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "arance da tavola al kg",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 58.01194820898926,
                                "left": 28.24124058696321,
                                "width": 22.124977028343817,
                                "height": 19.276858941209657
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/12_0WgAFBS_c7KuRA0.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_2Y5ay5n_TXece8F.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm81722840",
                            "field1": "finocchio",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "finocchio al kg",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 58.01194820898926,
                                "left": 50.36621761530702,
                                "width": 22.24652647189551,
                                "height": 19.276858941209657
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/13_SS8tRud_0US7DJb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_Yd7loAr_XTCehp9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm98988380",
                            "field1": "pomodoro costoluto",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "pomodoro costoluto al kg",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 58.01194820898926,
                                "left": 72.61274408720254,
                                "width": 24.191598036617886,
                                "height": 19.276858941209657
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/14_jWEduOS_rteYkat.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_9elbRcB_3fszVUo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99063448",
                            "field1": "melanzana nera",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "melanzana nera al kg",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 77.2888071501989,
                                "left": 72.61274408720254,
                                "width": 24.191598036617886,
                                "height": 18.234870626837733
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/17_V2Fk9bG_PbGkcoS.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_KBTW38W_oabdbCh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm30219875",
                            "field1": "broccoli di rape",
                            "field2": "",
                            "field3": "al kg",
                            "field4": "",
                            "description": "broccoli di rape al kg",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 77.2888071501989,
                                "left": 50.48778041447278,
                                "width": 22.124963672729763,
                                "height": 18.234870626837733
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/16_mppDNwI_pNNWnku.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_6kXNw6K_CjTiENu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm43750670",
                            "field1": "fragole vaschetta",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "fragole vaschetta",
                            "grammage": null,
                            "price": "0.00",
                            "price_label": "PRENDI 3 NE PAGHI 2",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 77.2888071501989,
                                "left": 5.265310608845056,
                                "width": 45.222469805627725,
                                "height": 18.234870626837733
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/15_XjpL9q0_W3sArli.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_WcvAara_QgcoUBL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_5_xyN8jf2.jpg",
                    "products": [
                        {
                            "item_id": "cstm98316932",
                            "field1": "minestrone classico",
                            "field2": "la valle degli orti",
                            "field3": "gr.850",
                            "field4": "",
                            "description": "minestrone classico la valle degli orti gr.850",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 13.076027753614719,
                                "left": 2.7124317261009296,
                                "width": 32.45806203629307,
                                "height": 30.087527948530365
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/18_QsAoWcB_ggQ66Eb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_pHkljrj_wiaNiD9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.lavalledegliorti.it/prodotti/minestrone-classico/"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84721510",
                            "field1": "misto per soffritt",
                            "field2": "orogel",
                            "field3": "gr.300",
                            "field4": "",
                            "description": "misto per soffritt orogel gr.300",
                            "grammage": null,
                            "price": "1.30",
                            "price_label": "€ 1,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 13.076027753614719,
                                "left": 35.170493762394,
                                "width": 29.54048140043764,
                                "height": 14.978640151791515
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/19_l4Bm0dm_6teax8e.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_EevxN0s_QimCu5H.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm46652498",
                            "field1": "carciofi interi",
                            "field2": "orogel",
                            "field3": "tanto cuore",
                            "field4": "gr.300",
                            "description": "carciofi interi orogel tanto cuore gr.300",
                            "grammage": null,
                            "price": "2.20",
                            "price_label": "€ 2,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 28.05466790540624,
                                "left": 35.170493762394,
                                "width": 29.54048140043763,
                                "height": 15.239137230384495
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/20_m1Li8eF_RqwqIlq.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_vG07Z4e_hUsqfxV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Carciofi interi",
                                        "testo": "Una tenera e deliziosa parte interna dentro una solida armatura. I Carciofi Interi TantoCuore, gustosi dal sapore naturale, si prestano a tantissime ricette come torte salate, pizze, primi e ripieni. (Fonte: orogel.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/images/4723_n_Orogel_retail_I-Vegetali-tal-quali_Tanto-cuore_carciofi-interi_300g.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm15670120",
                            "field1": "mix di funghi con porcini",
                            "field2": "luna funghi",
                            "field3": "gr.500",
                            "field4": "",
                            "description": "mix di funghi con porcini luna funghi gr.500",
                            "grammage": null,
                            "price": "2.30",
                            "price_label": "€ 2,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 12.555031807730444,
                                "left": 65.07567023813594,
                                "width": 30.026752630521745,
                                "height": 30.73877332806028
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/21_w4oCIwO_tPUqhAZ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_SSFDjzk_WgcKnP1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm82617407",
                            "field1": "bastoncini di merluzzo",
                            "field2": "crai",
                            "field3": "x12 gr.300",
                            "field4": "",
                            "description": "bastoncini di merluzzo crai x12 gr.300",
                            "grammage": null,
                            "price": "1.90",
                            "price_label": "€ 1,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 43.29380513579073,
                                "left": 65.07567023813594,
                                "width": 30.026752630521745,
                                "height": 33.604253713471245
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/25_foZkDSw_cizhBkq.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_fG6fShG_jL9DEVp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88797598",
                            "field1": "crepes",
                            "field2": "crai",
                            "field3": "vari tipi",
                            "field4": "gr.200",
                            "description": "crepes crai vari tipi gr.200",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 43.29380513579073,
                                "left": 35.04892428542122,
                                "width": 30.026745952714712,
                                "height": 33.604253713471245
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/23_0DgzxZ7_5YqmtC7.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/24_bOv205E_lhb4Y5K.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_a5aLWKw_OsEOM0o.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84499410",
                            "field1": "cotolette",
                            "field2": "crai",
                            "field3": "gr.300",
                            "field4": "",
                            "description": "cotolette crai gr.300",
                            "grammage": null,
                            "price": "1.95",
                            "price_label": "€ 1,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 43.29380513579073,
                                "left": 4.171218705125137,
                                "width": 30.877705580296084,
                                "height": 33.604253713471245
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/22_MNsZGWB_mmgxwzT.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_rHT0HBq_s3QsF2P.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm75909968",
                            "field1": "spinaci con mozzarella",
                            "field2": "crai",
                            "field3": "gr.600",
                            "field4": "",
                            "description": "spinaci con mozzarella crai gr.600",
                            "grammage": null,
                            "price": "1.75",
                            "price_label": "€ 1,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 76.89805884926196,
                                "left": 4.171218705125137,
                                "width": 23.462194530395237,
                                "height": 18.886110640272715
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/26_FpKQksD_JXPMFlX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_gU05Lwo_RrzyJZl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm94367593",
                            "field1": "Branzino al pepe rosa",
                            "field2": "crai",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "Branzino al pepe rosa crai gr.250",
                            "grammage": null,
                            "price": "3.90",
                            "price_label": "€ 3,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 76.89805884926196,
                                "left": 27.633413235520372,
                                "width": 22.368102626675327,
                                "height": 18.886110640272715
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/27_yJUHX5l_7Th2Lkk.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_81fzGeq_5w2Kp5t.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm91631604",
                            "field1": "filetti di platessa panata ",
                            "field2": "findus",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "filetti di platessa panata  findus gr.250",
                            "grammage": null,
                            "price": "3.90",
                            "price_label": "€ 3,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 76.89805884926196,
                                "left": 50.0015158621957,
                                "width": 22.489665425841082,
                                "height": 18.886110640272715
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/28_vF2WRf0_OxxA0kk.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_VgdEC0f_ouEiJMN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42383877",
                            "field1": "condiscoglio al pomodoro",
                            "field2": "arbi",
                            "field3": "gr.450",
                            "field4": "",
                            "description": "condiscoglio al pomodoro arbi gr.450",
                            "grammage": null,
                            "price": "3.40",
                            "price_label": "€ 3,40",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 76.89805884926196,
                                "left": 72.49118128803678,
                                "width": 23.583770685175054,
                                "height": 18.886110640272715
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/29_n7xfz4e_MIz9nB9.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_mCoLZZC_3Di5PiD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 6,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_6_UpvkhSj.jpg",
                    "products": [
                        {
                            "item_id": "cstm48740521",
                            "field1": "bel paese",
                            "field2": "galbani",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "bel paese galbani all'etto",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 12.555030019032136,
                                "left": 1.9830348976853118,
                                "width": 32.944326588570156,
                                "height": 38.68396910476327
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/1_TPEQNhX_VkvdkVb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_LpeEIm5_H5BJubb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm79429338",
                            "field1": "provolone piccante",
                            "field2": "auricchio",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "provolone piccante auricchio all'etto",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 12.555030019032136,
                                "left": 34.92736148625547,
                                "width": 29.905176475741932,
                                "height": 38.68396910476327
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/2_3QcTWOi_Ldy5wu8.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_5ITIv2J_Ftk48je.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73732025",
                            "field1": "parmigiano reggiano selezione dop",
                            "field2": "crai",
                            "field3": "22 mesi all'etto",
                            "field4": "",
                            "description": "parmigiano reggiano selezione dop crai 22 mesi all'etto",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 12.555030019032136,
                                "left": 64.83253796199739,
                                "width": 32.70119431243162,
                                "height": 38.68396910476327
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/3_hstRkbT_9cXokEy.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_PEWIofW_bg4WwbS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80285167",
                            "field1": "formaggio occhiato",
                            "field2": "bavarese",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "formaggio occhiato bavarese all'etto",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 51.10874611275313,
                                "left": 3.928093106793627,
                                "width": 23.826889605699535,
                                "height": 22.923835928494498
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/4_PWIj55s_Xf2o0GQ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_6SkwQRW_Nmx2sk9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm98632542",
                            "field1": "formaggio crema",
                            "field2": "di rugiada",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "formaggio crema di rugiada all'etto",
                            "grammage": null,
                            "price": "0.85",
                            "price_label": "€ 0,85 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 74.03258204124762,
                                "left": 3.928093106793627,
                                "width": 23.826889605699535,
                                "height": 21.230589713704475
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/5_pgdSTvd_HQs7COd.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_sakOSDG_V4eVKAm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm81317486",
                            "field1": "pecorino fresco classico",
                            "field2": "fattorie della piana",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "pecorino fresco classico fattorie della piana all'etto",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 69.86461447417344,
                                "left": 27.75498271249316,
                                "width": 22.732801040883135,
                                "height": 25.39855728077866
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/6_9vZsbxa_KDkxCNO.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_B95Tvt6_DtYOf1g.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09538630",
                            "field1": "provola",
                            "field2": "morrone",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "provola morrone all'etto",
                            "grammage": null,
                            "price": "0.55",
                            "price_label": "€ 0,55 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 78.20055676311505,
                                "left": 50.4877837533763,
                                "width": 26.379765149540138,
                                "height": 17.062614991837048
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/8_tVB7zC2_rELz5gv.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_clK2uvC_6aM7L3g.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm90023886",
                            "field1": "mozzarella fiordilatte",
                            "field2": "croce di magara",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "mozzarella fiordilatte croce di magara all'etto",
                            "grammage": null,
                            "price": "0.75",
                            "price_label": "€ 0,75 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 53.192729896290224,
                                "left": 50.4877837533763,
                                "width": 15.560408911506768,
                                "height": 25.00782686682484
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/7_nk8tUrc_FkoXrN4.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_xtJWDCT_DQAYBJG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm83992040",
                            "field1": "olive alla monacale",
                            "field2": "facino",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "olive alla monacale facino all'etto",
                            "grammage": null,
                            "price": "0.59",
                            "price_label": "€ 0,59 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 53.192729896290224,
                                "left": 66.04819266488306,
                                "width": 16.411388572509228,
                                "height": 23.44484081787033
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/9_Qk7lacI_ZZnGRLQ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_7pQ97y6_AQXp69Q.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm85087843",
                            "field1": "filetti salinati",
                            "field2": "molva ling",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "filetti salinati molva ling all'etto",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 76.63757071416055,
                                "left": 79.17730552623256,
                                "width": 17.748599396753622,
                                "height": 19.53734349891445
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/10_cCLif5L_n0OpbCD.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_4L0c0KY_5URWh5G.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 7,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_7_00Tod5d.jpg",
                    "products": [
                        {
                            "item_id": "cstm22292118",
                            "field1": "prosciutto cotto A.Q.",
                            "field2": "teneroni",
                            "field3": "al kg",
                            "field4": "",
                            "description": "prosciutto cotto A.Q. teneroni al kg",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 12.29452936304253,
                                "left": 2.7124384039079596,
                                "width": 24.92098150941945,
                                "height": 19.797856675792236
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/11_fwvXa6D_1WPUTa8.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_qYqprUg_E6qpxuo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm04388631",
                            "field1": "prosciutto cotto",
                            "field2": "pordoi veroni",
                            "field3": "al kg",
                            "field4": "",
                            "description": "prosciutto cotto pordoi veroni al kg",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 12.29452936304253,
                                "left": 27.63341991332741,
                                "width": 22.489672103648108,
                                "height": 19.797856675792236
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/12_RlCV7ar_AGsjfGZ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_TdGpJUU_K37KCd2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm94082715",
                            "field1": "prosciutto crudo di norcia",
                            "field2": "salpi",
                            "field3": "al kg",
                            "field4": "",
                            "description": "prosciutto crudo di norcia salpi al kg",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 12.29452936304253,
                                "left": 50.12309201697551,
                                "width": 22.246539827509576,
                                "height": 19.797856675792236
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/13_zwMC7nd_lJ6k3dm.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_FIe0uNF_FP82brc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51896312",
                            "field1": "speck montagna",
                            "field2": "senfter",
                            "field3": "al kg",
                            "field4": "",
                            "description": "speck montagna senfter al kg",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 12.29452936304253,
                                "left": 72.36963184448508,
                                "width": 24.31315415797661,
                                "height": 19.797856675792236
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/14_pERDiwJ_lyUuTlz.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_7cmeE1z_EMtsWNL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06763958",
                            "field1": "salame napoli",
                            "field2": "galbani",
                            "field3": "al kg",
                            "field4": "",
                            "description": "salame napoli galbani al kg",
                            "grammage": null,
                            "price": "1.15",
                            "price_label": "€ 1,15 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 32.09238603883477,
                                "left": 72.36963184448508,
                                "width": 24.31315415797661,
                                "height": 18.75586120662707
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/18_Uuq9TMl_VvbhlRP.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_DOg1QVQ_nHEXK5e.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm78365615",
                            "field1": "porchella arrosto",
                            "field2": "beretta",
                            "field3": "al kg",
                            "field4": "",
                            "description": "porchella arrosto beretta al kg",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 32.09238603883477,
                                "left": 49.879966418644,
                                "width": 22.489665425841086,
                                "height": 18.75586120662707
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/17_KQ0uCGi_5hnNPhU.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_jMNf9IC_NdG0LSn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm27881992",
                            "field1": "bresaola punta d'anca",
                            "field2": "stella alpina",
                            "field3": "al kg",
                            "field4": "",
                            "description": "bresaola punta d'anca stella alpina al kg",
                            "grammage": null,
                            "price": "2.89",
                            "price_label": "€ 2,89 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 32.09238603883477,
                                "left": 27.75499606810723,
                                "width": 22.12497035053678,
                                "height": 18.75586120662707
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/16_4oFitmL_2clJlFH.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_pIQeaL3_NRcv71O.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm95415797",
                            "field1": "mortadella augustissima",
                            "field2": "galbani",
                            "field3": "al kg",
                            "field4": "",
                            "description": "mortadella augustissima galbani al kg",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 32.09238603883477,
                                "left": 3.6849741862691494,
                                "width": 24.070021881838077,
                                "height": 18.75586120662707
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/15_sfjvObf_Fh2C5Wp.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_nC3mk3L_7WvZwis.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm63793010",
                            "field1": "mozzarella julienne",
                            "field2": "bayernland",
                            "field3": "gr.200",
                            "field4": "",
                            "description": "mozzarella julienne bayernland gr.200",
                            "grammage": null,
                            "price": "1.85",
                            "price_label": "€ 1,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 61.00767445064925,
                                "left": 1.6183465001880466,
                                "width": 26.258205689277897,
                                "height": 17.844118748504172
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/19_OHyQjcH_5rDfPiI.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_8gg8tIj_vqANWBg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Mozzarella julienne",
                                        "testo": "La qualità della nostra mozzarella nel pratico formato pretagliato a julienne in strisce da 6 mm subito pronte all’uso. (Fonte: bayernland.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/images/csm_Bayernland-prodotti-formaggio-71_1462e1aca0.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm53317148",
                            "field1": "mozzarella",
                            "field2": "la ottanta valcolatte",
                            "field3": "gr.80x3",
                            "field4": "",
                            "description": "mozzarella la ottanta valcolatte gr.80x3",
                            "grammage": null,
                            "price": "1.55",
                            "price_label": "€ 1,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 61.00767445064925,
                                "left": 27.87655218946594,
                                "width": 22.36810596557884,
                                "height": 17.844118748504172
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/20_izlphLY_79VeD8B.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_BETJl9Q_f7mP0m4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm68583202",
                            "field1": "crescenza AQ",
                            "field2": "crai",
                            "field3": "gr.165",
                            "field4": "",
                            "description": "crescenza AQ crai gr.165",
                            "grammage": null,
                            "price": "1.50",
                            "price_label": "€ 1,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 61.00767445064925,
                                "left": 50.24465815504479,
                                "width": 22.36809928777181,
                                "height": 17.844118748504172
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/21_TNmFnLm_QzuLOn2.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_xjZ0GWz_InRZI7A.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm65588813",
                            "field1": "ricotta alleggerita",
                            "field2": "centrali del latte",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "ricotta alleggerita centrali del latte gr.250",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 61.00767445064925,
                                "left": 72.6127574428166,
                                "width": 23.705323467630265,
                                "height": 34.12525144805383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/24_eYpoyhY_cEJ1aHE.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_k9jYRJp_fcUzcpc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm24141378",
                            "field1": "leerdammer",
                            "field2": "lightlife",
                            "field3": "gr.100",
                            "field4": "",
                            "description": "leerdammer lightlife gr.100",
                            "grammage": null,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 78.72154018811115,
                                "left": 50.00151920109922,
                                "width": 22.611238241717384,
                                "height": 16.411385710591933
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/23_pI6fE8t_dJVBHkf.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_7Whaa8k_eCgwJpd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm31536282",
                            "field1": "philadelphia",
                            "field2": "mondelez",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "philadelphia mondelez gr.250",
                            "grammage": null,
                            "price": "2.35",
                            "price_label": "€ 2,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 78.72154018811115,
                                "left": 3.928093106793627,
                                "width": 46.073426094305596,
                                "height": 16.97777824482648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/22_ynymn5i_N63z2Ej.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_vUAOVBq_0ENMdtJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Philadelphia.mp4"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 8,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_8_AowPZGV.jpg",
                    "products": [
                        {
                            "item_id": "cstm84108576",
                            "field1": "fiordilatte grill",
                            "field2": "galbanino",
                            "field3": "gr.200",
                            "field4": "",
                            "description": "fiordilatte grill galbanino gr.200",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 12.294532940439154,
                                "left": 3.1986962783780086,
                                "width": 24.434716957142367,
                                "height": 15.760134964967078
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/1_A0E7uKW_fZ3zkpk.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_U7zVUfi_PTEb5rF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80062266",
                            "field1": "formaggini",
                            "field2": "parmareggio",
                            "field3": "gr.140",
                            "field4": "",
                            "description": "formaggini parmareggio gr.140",
                            "grammage": null,
                            "price": "1.08",
                            "price_label": "€ 1,08",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 12.294532940439154,
                                "left": 27.633413235520372,
                                "width": 23.097499455090944,
                                "height": 15.760134964967078
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/2_YvQ17Zk_4WkdQBA.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_252mCTL_RiCSztG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm78147998",
                            "field1": "biraghini",
                            "field2": "biraghi",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "biraghini biraghi gr.250",
                            "grammage": null,
                            "price": "3.30",
                            "price_label": "€ 3,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 12.294532940439154,
                                "left": 50.73091269061132,
                                "width": 22.24653982750957,
                                "height": 15.760134964967078
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/3_WU4FcJu_wGAM0n1.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_ODGRlBQ_zSfsJVA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/BIRAGHINI_cubetti.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm78036890",
                            "field1": "pasta fresca ripiena",
                            "field2": "i rustici rana",
                            "field3": "vari tipi",
                            "field4": "gr.250",
                            "description": "pasta fresca ripiena i rustici rana vari tipi gr.250",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 12.294532940439154,
                                "left": 72.9774525181209,
                                "width": 23.705326806533783,
                                "height": 30.999272195351576
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/7_eAWFm32_My2qI45.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/8_G4pqxiN_vuWJ2jM.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_0oSwpzI_B3ky6WT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88299478",
                            "field1": "pasta sfoglia delicata",
                            "field2": "buitoni",
                            "field3": "gr.230",
                            "field4": "",
                            "description": "pasta sfoglia delicata buitoni gr.230",
                            "grammage": null,
                            "price": "1.35",
                            "price_label": "€ 1,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 27.924418471760585,
                                "left": 50.60934989144557,
                                "width": 22.368102626675327,
                                "height": 15.36938666403014
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/6_8UkSldR_RCzCru3.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_HRTDu3l_cmSaXn3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51443167",
                            "field1": "mascarpone",
                            "field2": "crai",
                            "field3": "gr.500",
                            "field4": "",
                            "description": "mascarpone crai gr.500",
                            "grammage": null,
                            "price": "2.95",
                            "price_label": "€ 2,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 28.18491733905188,
                                "left": 27.511850436354628,
                                "width": 23.097499455090944,
                                "height": 15.10888779673885
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/5_w07RylX_zLw9La5.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_vge1VHZ_xuOFD4k.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm31522042",
                            "field1": "burro",
                            "field2": "parmareggio",
                            "field3": "gr.100",
                            "field4": "",
                            "description": "burro parmareggio gr.100",
                            "grammage": null,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 28.18491733905188,
                                "left": 4.049659244862903,
                                "width": 23.462191191491726,
                                "height": 15.10888779673885
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/4_09SFqY1_oiKSkUM.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_C4QzjFz_F7lv6gO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm53897080",
                            "field1": "prosciutto cotto a cubetti",
                            "field2": "crai",
                            "field3": "gr.70x2",
                            "field4": "",
                            "description": "prosciutto cotto a cubetti crai gr.70x2",
                            "grammage": null,
                            "price": "2.25",
                            "price_label": "€ 2,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 43.29380513579073,
                                "left": 4.049659244862903,
                                "width": 46.80281624491418,
                                "height": 18.104617615795462
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/9_KRNJkGU_8RVP686.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_KHzfwkL_Sv6l0Jh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm90891361",
                            "field1": "salame cacciatore dop",
                            "field2": "crai",
                            "field3": "gr.175",
                            "field4": "",
                            "description": "salame cacciatore dop crai gr.175",
                            "grammage": null,
                            "price": "2.25",
                            "price_label": "€ 2,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 43.29380513579073,
                                "left": 50.85247548977708,
                                "width": 22.003410890274548,
                                "height": 18.104617615795462
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/10_fhWKIEa_RPn7RsM.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_1s2BSRq_Y7vIx9E.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80698745",
                            "field1": "prosciutto cotto",
                            "field2": "aequilibrium aia",
                            "field3": "gr.120",
                            "field4": "",
                            "description": "prosciutto cotto aequilibrium aia gr.120",
                            "grammage": null,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 43.29380513579073,
                                "left": 72.85588638005161,
                                "width": 24.07002522074159,
                                "height": 18.104617615795462
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/11_JJeNbig_DYn1w8f.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_j785aZf_scGNUN7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm21008948",
                            "field1": "puroblu",
                            "field2": "parmalat",
                            "field3": "",
                            "field4": "",
                            "description": "puroblu parmalat",
                            "grammage": null,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 61.39842275158618,
                                "left": 50.60934655254205,
                                "width": 44.371506839142846,
                                "height": 33.343758423576574
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/16_R4TxkDG_UztafZv.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_QwSoO2g_mqwXpm3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm26411321",
                            "field1": "pesto/ sugo fresco",
                            "field2": "buitoni",
                            "field3": "vari tipi",
                            "field4": "",
                            "description": "pesto/ sugo fresco buitoni vari tipi",
                            "grammage": null,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pesto",
                                "Sugo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 61.39842275158617,
                                "left": 27.147155361050338,
                                "width": 23.462191191491726,
                                "height": 17.32312459131821
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/13_YGE496x_9C3vOvv.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_032afTR_inNbCpi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm10054211",
                            "field1": "muu muu mini",
                            "field2": "cameo",
                            "field3": "cioccolato/ vaniglia",
                            "field4": "gr.50x6",
                            "description": "muu muu mini cameo cioccolato/ vaniglia gr.50x6",
                            "grammage": null,
                            "price": "1.85",
                            "price_label": "€ 1,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cioccolto",
                                "Vaniglia"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 78.72154734290439,
                                "left": 27.147155361050338,
                                "width": 23.462191191491726,
                                "height": 16.150883265904017
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/15_YzuJmpd_mV4Q27S.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_HErhEL2_qT4Wlz6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17470370",
                            "field1": "fruttolo maxiduo",
                            "field2": "",
                            "field3": "vari gusti",
                            "field4": "gr.100x4",
                            "description": "fruttolo maxiduo vari gusti gr.100x4",
                            "grammage": null,
                            "price": "1.75",
                            "price_label": "€ 1,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 78.72154734290439,
                                "left": 4.29278818209793,
                                "width": 22.8543671789524,
                                "height": 16.150883265904017
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/14_nm7fLxJ_Rk6LxSm.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_xBSpDwF_fi3nilZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Fr%C3%B9ttolo_Maxi_Duo_due_gusti_da_mischiare_nel_formato_da_100_grammi..mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm32570087",
                            "field1": "tagliatelle/ tagliolini",
                            "field2": "piaceri crai",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "tagliatelle/ tagliolini piaceri crai gr.250",
                            "grammage": null,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Tagliolini",
                                "Tagliatelle"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 61.52867576262847,
                                "left": 4.29278818209793,
                                "width": 22.85436717895241,
                                "height": 17.19287158027594
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/12_nOP6arL_1MbiasI.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_PCOPhYY_iilToaf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 9,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_9_KtDtH71.jpg",
                    "products": [
                        {
                            "item_id": "cstm23862474",
                            "field1": "Passata di pomodoro",
                            "field2": "la fiammante",
                            "field3": "gr.700",
                            "field4": "",
                            "description": "Passata di pomodoro la fiammante gr.700",
                            "grammage": null,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 12.557427625749728,
                                "left": 1.2654311784351144,
                                "width": 21.827290076335878,
                                "height": 32.331992911668486
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/17_oqTr7Nl_4Zm83Sl.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_3ZReNzO_MTnmRxI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Passata",
                                        "testo": "\nPRECSUCC\nPASSATA DI POMODORO LA FIAMMANTE, DENSA E FRAGRANTE \nIdeale per ogni tipo di sugo di pomodoro grazie alla sua naturale dolcezza e alla ottima densità, La Passata di Pomodoro La Fiammante conserva il sapore autentico delle migliori materie prime italiane.\n\nLa passata di pomodoro è realizzata solo pomodori freschi selezionati con competenza e responsabilità, conferiti in azienda in tempi brevissimi dalla loro raccolta meccanica e lavorati con procedimenti innovativi che garantiscono di preservarne l’alta qualità. Una passata indicata per tutte le ricette più semplici e le cotture medie o brevi, grazie all’inimitabile, cremosa concentrazione. (Fonte: lafiammante.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/images/17_oqTr7Nl_4Zm83Sl.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm28921346",
                            "field1": "sugo al ragù",
                            "field2": "crai",
                            "field3": "gr.400",
                            "field4": "",
                            "description": "sugo al ragù crai gr.400",
                            "grammage": null,
                            "price": "1.35",
                            "price_label": "€ 1,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 12.557427625749728,
                                "left": 23.092721254770993,
                                "width": 17.652671755725194,
                                "height": 16.229893675027263
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/18_w6SeNla_xq5qX3y.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_vhzdU54_QoxChlE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35487483",
                            "field1": "legumi",
                            "field2": "valfrutta",
                            "field3": "vari tipi",
                            "field4": "gr.400x3",
                            "description": "legumi valfrutta vari tipi gr.400x3",
                            "grammage": null,
                            "price": "2.30",
                            "price_label": "€ 2,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 28.787321300776988,
                                "left": 23.092721254770993,
                                "width": 17.652671755725194,
                                "height": 15.84651035986914
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/20_baa2lpI_hYPFrf9.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_zoQchFO_9XPO8rY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm75969117",
                            "field1": "mais supersweer",
                            "field2": "valfrutta",
                            "field3": "gr.326",
                            "field4": "",
                            "description": "mais supersweer valfrutta gr.326",
                            "grammage": null,
                            "price": "2.55",
                            "price_label": "€ 2,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 28.787321300776988,
                                "left": 40.74539301049619,
                                "width": 17.891221374045802,
                                "height": 15.84651035986914
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/21_2JE7Ey3_2NdTExR.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_Fwwm0gR_h4MVeTw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm21824700",
                            "field1": "dadi",
                            "field2": "knorr",
                            "field3": "vari tipi x10",
                            "field4": "",
                            "description": "dadi knorr vari tipi x10",
                            "grammage": null,
                            "price": "0.90",
                            "price_label": "€ 0,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 12.174044310591603,
                                "left": 40.74539301049619,
                                "width": 17.891221374045802,
                                "height": 16.61327699018539
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/19_N7cTDaH_Jmb5PLK.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_FcVyySQ_JJZwFFc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06049792",
                            "field1": "tarallucci",
                            "field2": "colacchio",
                            "field3": "classici/ finocchio",
                            "field4": "gr.250",
                            "description": "tarallucci colacchio classici/ finocchio gr.250",
                            "grammage": null,
                            "price": "1.20",
                            "price_label": "€ 1,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classici",
                                "Finocchio"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 12.174044310591603,
                                "left": 59.11371362118321,
                                "width": 21.827290076335878,
                                "height": 32.331992911668486
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/22_Q8u86o9_PZsUpjx.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/23_s3gArEb_AQKw8Bp.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_mFl8DfP_S8PHcvr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17254059",
                            "field1": "olio di semi di girasole",
                            "field2": "belvedere",
                            "field3": "lt.1",
                            "field4": "",
                            "description": "olio di semi di girasole belvedere lt.1",
                            "grammage": null,
                            "price": "1.45",
                            "price_label": "€ 1,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 12.174044310591603,
                                "left": 80.9410036975191,
                                "width": 14.432251908396948,
                                "height": 32.331992911668486
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/24_nvvjzxl_sz4DX9X.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_Afgb7L7_mto6Pkj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm43152103",
                            "field1": "farina tipo \"00\"",
                            "field2": "caputo",
                            "field3": "pizzeria/ rossa",
                            "field4": "kg.1",
                            "description": "farina tipo \"00\" caputo pizzeria/ rossa kg.1",
                            "grammage": null,
                            "price": "0.90",
                            "price_label": "€ 0,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pizzeria",
                                "Rossa"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.88942053741821,
                                "left": 72.3532174379771,
                                "width": 23.02003816793893,
                                "height": 16.485482551799347
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/28_A7GRSCQ_Ejt6oGy.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/29_UgPJsYO_KYUUs0C.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_5nNIQgq_wd7zcQ2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23069174",
                            "field1": "tonno in O.O.",
                            "field2": "crai",
                            "field3": "gr.80x3",
                            "field4": "",
                            "description": "tonno in O.O. crai gr.80x3",
                            "grammage": null,
                            "price": "2.30",
                            "price_label": "€ 2,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 44.88942053741821,
                                "left": 50.16810293416031,
                                "width": 22.1851145038168,
                                "height": 16.485482551799347
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/27_n5lcm3A_i5mF9sy.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_dBzTprJ_ekxi5kf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm92398449",
                            "field1": "funghi tagliati al naturale",
                            "field2": "iposea",
                            "field3": "gr.425",
                            "field4": "",
                            "description": "funghi tagliati al naturale iposea gr.425",
                            "grammage": null,
                            "price": "1.20",
                            "price_label": "€ 1,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.88942053741821,
                                "left": 27.50588919370229,
                                "width": 22.662213740458014,
                                "height": 16.485482551799347
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/26_VhExmWp_FvJpRK0.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_7wsXd7t_8buWNt5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm63199440",
                            "field1": "capperi al sale",
                            "field2": "saclà",
                            "field3": "gr.65",
                            "field4": "",
                            "description": "capperi al sale saclà gr.65",
                            "grammage": null,
                            "price": "1.38",
                            "price_label": "€ 1,38",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.88942053741821,
                                "left": 4.605125834923665,
                                "width": 22.90076335877863,
                                "height": 16.485482551799347
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/25_IqwHEDL_y7nP1fx.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_inI1DVR_9XtYKu4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm47462583",
                            "field1": "olio extra vergine",
                            "field2": "san giovanni desantis",
                            "field3": "lt.1",
                            "field4": "",
                            "description": "olio extra vergine san giovanni desantis lt.1",
                            "grammage": null,
                            "price": "3.30",
                            "price_label": "€ 3,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 61.374903089217554,
                                "left": 4.605125834923665,
                                "width": 22.90076335877863,
                                "height": 33.35434841875682
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/30_oEGZrxx_M5pwv7w.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_fbvCV46_070VXiJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm71586850",
                            "field1": "gnocchi di patate",
                            "field2": "rummo",
                            "field3": "gr.500",
                            "field4": "",
                            "description": "gnocchi di patate rummo gr.500",
                            "grammage": null,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 61.374903089217554,
                                "left": 27.50588919370229,
                                "width": 22.542938931297712,
                                "height": 16.102099236641223
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/31_PCuy2J1_4yNEuPX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_3Em93az_iwgEI6N.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88984283",
                            "field1": "pasta integrale",
                            "field2": "garofalo",
                            "field3": "varie trafile",
                            "field4": "gr.500",
                            "description": "pasta integrale garofalo varie trafile gr.500",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 61.374903089217554,
                                "left": 50.048828125,
                                "width": 22.423664122137406,
                                "height": 16.102099236641223
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/32_I1NIqCI_iB0YjcU.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_CbaCo81_f5EDtNL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm71020139",
                            "field1": "riso arborio",
                            "field2": "gallo",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "riso arborio gallo kg.1",
                            "grammage": null,
                            "price": "2.60",
                            "price_label": "€ 2,60",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 61.374903089217554,
                                "left": 72.47249224713741,
                                "width": 23.61641221374046,
                                "height": 16.102099236641223
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/33_TsJYLmt_Iz8FhWq.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_rnvzhZ3_jfV23Hy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm64460795",
                            "field1": "pan bauletto",
                            "field2": "mulino bianco",
                            "field3": "grano duro",
                            "field4": "gr.400",
                            "description": "pan bauletto mulino bianco grano duro gr.400",
                            "grammage": null,
                            "price": "0.98",
                            "price_label": "€ 0,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.47700232585878,
                                "left": 72.47249224713741,
                                "width": 23.61641221374046,
                                "height": 17.12445474372955
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/36_cTVBbpi.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_cxcVUTL_jeFRXPZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.mulinobianco.it/pan-bauletto-al-grano-duro"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm43120210",
                            "field1": "tarallini classici",
                            "field2": "trifone",
                            "field3": "multipack",
                            "field4": "gr.210",
                            "description": "tarallini classici trifone multipack gr.210",
                            "grammage": null,
                            "price": "0.80",
                            "price_label": "€ 0,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.47700232585878,
                                "left": 50.048828125,
                                "width": 22.423664122137406,
                                "height": 17.12445474372955
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/35_qYj0a7u.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_MaBZBXZ_I6q11VK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm79546312",
                            "field1": "maionese",
                            "field2": "crai",
                            "field3": "tubo",
                            "field4": "gr.143",
                            "description": "maionese crai tubo gr.143",
                            "grammage": null,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 77.47700232585878,
                                "left": 27.50588919370229,
                                "width": 22.542938931297712,
                                "height": 17.12445474372955
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/34_Vw0D3hv_RPJchrm.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_caKGtKB_v4TNISC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 10,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_10_iWFAWml.jpg",
                    "products": [
                        {
                            "item_id": "cstm11447781",
                            "field1": "pane integrale a fette",
                            "field2": "crai",
                            "field3": "gr.400",
                            "field4": "",
                            "description": "pane integrale a fette crai gr.400",
                            "grammage": null,
                            "price": "0.68",
                            "price_label": "€ 0,68",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 12.046249872205562,
                                "left": 5.082225071564885,
                                "width": 18.010496183206108,
                                "height": 16.61327699018539
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/1_f3NzCvX_3NAD0Vb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_hP6x9G9_4Eoi7G1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm48099576",
                            "field1": "patatine",
                            "field2": "crik crok",
                            "field3": "original/ puff",
                            "field4": "gr.50/80",
                            "description": "patatine crik crok original/ puff gr.50/80",
                            "grammage": null,
                            "price": "0.55",
                            "price_label": "€ 0,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Original",
                                "Puff"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 12.046249872205562,
                                "left": 23.092721254770993,
                                "width": 18.24904580152672,
                                "height": 16.61327699018539
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/2_DPdTsM3_60d6wv1.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/3_DuFfl1A_IXXqIUJ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_X3hmrNz_IZGRN9a.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm87053911",
                            "field1": "patatine rustiche",
                            "field2": "crai",
                            "field3": "gr.150",
                            "field4": "",
                            "description": "patatine rustiche crai gr.150",
                            "grammage": null,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 12.046249872205562,
                                "left": 41.34176705629771,
                                "width": 18.48759541984733,
                                "height": 16.61327699018539
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/4_dmLMGvF_a7nXqor.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_7FiQzAH_Cst6M3N.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77247027",
                            "field1": "biscotti",
                            "field2": "plasmon",
                            "field3": "gr.120",
                            "field4": "",
                            "description": "biscotti plasmon gr.120",
                            "grammage": null,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Prima infanzia",
                            "subcategory": "Puericultura",
                            "blueprint": {
                                "top": 12.046249872205562,
                                "left": 59.82936247614504,
                                "width": 17.771946564885496,
                                "height": 16.61327699018539
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/5_n8P19pi_tqQbJy8.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_Dd6iz30_VoxMYW3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm16829854",
                            "field1": "fiamme al cocco",
                            "field2": "gecchele",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "fiamme al cocco gecchele gr.250",
                            "grammage": null,
                            "price": "1.50",
                            "price_label": "€ 1,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 12.046249872205562,
                                "left": 77.60130904103055,
                                "width": 18.48759541984733,
                                "height": 16.61327699018539
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/6_cSnfJtN_2OHkq9y.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_k7ybW9H_nSpPTJT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51666188",
                            "field1": "panna vegetale",
                            "field2": "hoplà",
                            "field3": "ml.500",
                            "field4": "",
                            "description": "panna vegetale hoplà ml.500",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 28.65952686239095,
                                "left": 77.60130904103055,
                                "width": 18.48759541984733,
                                "height": 32.843170665212654
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/8_5c35iqG_vresCgV.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_taP2suH_cWemAkm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm91784439",
                            "field1": "fonzies",
                            "field2": "original",
                            "field3": "gr.280",
                            "field4": "",
                            "description": "fonzies original gr.280",
                            "grammage": null,
                            "price": "3.19",
                            "price_label": "€ 3,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 28.65952686239095,
                                "left": 59.82936247614504,
                                "width": 17.771946564885496,
                                "height": 32.843170665212654
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/7_KGXaiWV_fTG7ade.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_daDxZFH_VeTcWnZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/FONZIES_NUOVO_SPOT_2020_20s.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm03063326",
                            "field1": "Calvé",
                            "field2": "Acquista 2 salse Calvé",
                            "field3": "Vinci ogni settmana un SET DI PIATTI VINILE",
                            "field4": "Estrazione finale d un BUONO DA 100€ per partecipare ai tuoi concerti preferiti in streaming ",
                            "description": "Calvé Acquista 2 salse Calvé Vinci ogni settmana un SET DI PIATTI VINILE Estrazione finale d un BUONO DA 100€ per partecipare ai tuoi concerti preferiti in streaming ",
                            "grammage": null,
                            "price": "1.60",
                            "price_label": "€ 1,60",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 61.502697527603594,
                                "left": 59.82936247614504,
                                "width": 35.06679389312978,
                                "height": 32.587581788440566
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/Calve-SalsaMaioneseClassica250ml_A3kvPkK.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_ml9i5D9_VDyqHZb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51690585",
                            "field1": "tavolette cioccolato spesse",
                            "field2": "coted'or",
                            "field3": "extra fondente/ fondente e nocciole",
                            "field4": "",
                            "description": "tavolette cioccolato spesse coted'or extra fondente/ fondente e nocciole",
                            "grammage": null,
                            "price": "1.98",
                            "price_label": "€ 1,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Extra fondente",
                                "Fondente e nocciole"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 77.60479676424482,
                                "left": 41.46104186545802,
                                "width": 18.368320610687025,
                                "height": 16.485482551799347
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/20_hPuQJLB_4fJgaYQ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_z7nLdCk_kMSn80j.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm34933831",
                            "field1": "tavolette cioccolato",
                            "field2": "ritter sport",
                            "field3": "vari tipi",
                            "field4": "gr.100",
                            "description": "tavolette cioccolato ritter sport vari tipi gr.100",
                            "grammage": null,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 77.60479676424482,
                                "left": 23.092721254770993,
                                "width": 18.368320610687025,
                                "height": 16.485482551799347
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/19_NqTxPLr_ILPFQK7.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_gpyo6mM_7yU5Ysd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm21468636",
                            "field1": "baiocchi",
                            "field2": "mulino bianco",
                            "field3": "gr.260",
                            "field4": "",
                            "description": "baiocchi mulino bianco gr.260",
                            "grammage": null,
                            "price": "1.90",
                            "price_label": "€ 1,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 77.60479676424482,
                                "left": 3.5316525524809164,
                                "width": 19.561068702290076,
                                "height": 16.485482551799347
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/18_sC3xZEU_ARhhTqu.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_D3DQHsZ_peXuGKD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Mulino_Bianco_-_Spot_2017_-_Baiocchi_30.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm54975468",
                            "field1": "ovetti con sorpresa",
                            "field2": "zaini",
                            "field3": "personaggi assortiti",
                            "field4": "gr.20x4",
                            "description": "ovetti con sorpresa zaini personaggi assortiti gr.20x4",
                            "grammage": null,
                            "price": "3.20",
                            "price_label": "€ 3,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 60.863725335673394,
                                "left": 3.5316525524809164,
                                "width": 19.322519083969468,
                                "height": 16.741071428571427
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/14_m5uaoVB_2mRi8Je.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_gL70yAQ_8yzTvYJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm30393683",
                            "field1": "maxi ovetti",
                            "field2": "witor's",
                            "field3": "vari tipi",
                            "field4": "gr.120",
                            "description": "maxi ovetti witor's vari tipi gr.120",
                            "grammage": null,
                            "price": "0.90",
                            "price_label": "€ 0,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 60.863725335673394,
                                "left": 22.85417163645038,
                                "width": 18.72614503816794,
                                "height": 16.741071428571427
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/15_F2JVnLg_QpmlkVb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_qMFFwaL_mgp12wg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm40091471",
                            "field1": "allegra pasqua/",
                            "field2": "witor's",
                            "field3": "latta/ feltro ovetti",
                            "field4": "gr.100",
                            "description": "allegra pasqua/ witor's latta/ feltro ovetti gr.100",
                            "grammage": null,
                            "price": "3.90",
                            "price_label": "€ 3,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Allegra pasqua",
                                "Latta",
                                "Feltro ovetti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 60.863725335673394,
                                "left": 41.580316674618324,
                                "width": 18.24904580152672,
                                "height": 16.741071428571427
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/17_kdpYk3N_qq7vEtL.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/16_AcsTgTt_BbdKAbl.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_a4iaQdR_mr5Cdi0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm70504968",
                            "field1": "torte",
                            "field2": "bauli",
                            "field3": "vari tipi",
                            "field4": "gr.375",
                            "description": "torte bauli vari tipi gr.375",
                            "grammage": null,
                            "price": "1.95",
                            "price_label": "€ 1,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.88942053741821,
                                "left": 41.580316674618324,
                                "width": 18.24904580152672,
                                "height": 15.974304798255181
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/13_BIowmlj_N4TwUaH.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_WSsSiWW_9fdEROG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm74770067",
                            "field1": "torta mimosa",
                            "field2": "motta",
                            "field3": "gr.350",
                            "field4": "",
                            "description": "torta mimosa motta gr.350",
                            "grammage": null,
                            "price": "2.80",
                            "price_label": "€ 2,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.88942053741821,
                                "left": 23.2119960639313,
                                "width": 18.368320610687025,
                                "height": 15.974304798255181
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/12_7aTlQLr_JEZhPqJ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_Iqoefk4_s537AAJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm68893989",
                            "field1": "mini colomba",
                            "field2": "balocco",
                            "field3": "personaggi assortiti",
                            "field4": "",
                            "description": "mini colomba balocco personaggi assortiti",
                            "grammage": null,
                            "price": "1.75",
                            "price_label": "€ 1,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.88942053741821,
                                "left": 4.128026598282443,
                                "width": 19.083969465648856,
                                "height": 15.974304798255181
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/11_ebdYDxU_UYP2BCV.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_s4LjRot_ymm2d2a.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm94427825",
                            "field1": "uovo latte",
                            "field2": "monardo",
                            "field3": "bimbo/ bimba",
                            "field4": "gr.150",
                            "description": "uovo latte monardo bimbo/ bimba gr.150",
                            "grammage": null,
                            "price": "1.90",
                            "price_label": "€ 1,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bimbo",
                                "Bimba"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 29.298499054321155,
                                "left": 23.2119960639313,
                                "width": 18.96469465648855,
                                "height": 16.229893675027263
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/9_BKOpmUb_y8mhSk4.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_hqoVv4m_PUG1ESb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm98697145",
                            "field1": "uova squadre calcio +sciarpa",
                            "field2": "morando",
                            "field3": "squadre assortite",
                            "field4": "gr.300",
                            "description": "uova squadre calcio +sciarpa morando squadre assortite gr.300",
                            "grammage": null,
                            "price": "8.50",
                            "price_label": "€ 8,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 29.298499054321155,
                                "left": 42.176690720419856,
                                "width": 17.17557251908397,
                                "height": 16.229893675027263
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/10_PRbZUf5_c4OtF3X.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_cxC4Jf3_zR5JLq3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 11,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_11_YWlPNCq.jpg",
                    "products": [
                        {
                            "item_id": "cstm42829534",
                            "field1": "latte italiano",
                            "field2": "parmalat",
                            "field3": "intero/ p.s./ scremato",
                            "field4": "lt.1",
                            "description": "latte italiano parmalat intero/ p.s./ scremato lt.1",
                            "grammage": null,
                            "price": "1.28",
                            "price_label": "€ 1,28",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Intero",
                                "P.S.",
                                "Scremato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 12.813016502521812,
                                "left": 5.367366412213741,
                                "width": 17.771946564885496,
                                "height": 17.380043620501638
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/22_F77O3UW_YMwJLIP.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/21_OBhfpnx_CzGMz40.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_pOGEQfF_1NOrH47.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm36972778",
                            "field1": "biscotti ai cereali",
                            "field2": "crai",
                            "field3": "gr.500",
                            "field4": "",
                            "description": "biscotti ai cereali crai gr.500",
                            "grammage": null,
                            "price": "1.55",
                            "price_label": "€ 1,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 12.813016502521812,
                                "left": 23.139312977099237,
                                "width": 18.12977099236641,
                                "height": 17.380043620501638
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/23_wvvqLST_UT0gS3Q.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_cKsNN4B_2wBwg9i.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm85549060",
                            "field1": "biscotti turco",
                            "field2": "galbusera",
                            "field3": "gr.400",
                            "field4": "",
                            "description": "biscotti turco galbusera gr.400",
                            "grammage": null,
                            "price": "1.85",
                            "price_label": "€ 1,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 12.813016502521812,
                                "left": 41.269083969465655,
                                "width": 18.010496183206108,
                                "height": 17.380043620501638
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/24_iMmNgcC_CBjqXzo.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_jyHuDGh_YyX5X3d.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm04566066",
                            "field1": "biscotto",
                            "field2": "frollotto",
                            "field3": "vari tipi x4",
                            "field4": "",
                            "description": "biscotto frollotto vari tipi x4",
                            "grammage": null,
                            "price": "2.90",
                            "price_label": "€ 2,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.193060123023447,
                                "left": 41.269083969465655,
                                "width": 18.010496183206108,
                                "height": 15.974304798255181
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/27_QYxbCWj_VfGzC8E.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_E6BsBzw_MJbnsgQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm96148862",
                            "field1": "biscotti oro",
                            "field2": "saiwa",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "biscotti oro saiwa gr.250",
                            "grammage": null,
                            "price": "0.98",
                            "price_label": "€ 0,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 30.193060123023447,
                                "left": 23.258587786259543,
                                "width": 18.010496183206108,
                                "height": 15.974304798255181
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/26_3ifAW8M_kpzi5Pq.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_wHSoRgP_C0xy9GF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60182437",
                            "field1": "biscotti",
                            "field2": "divella",
                            "field3": "vari tipi",
                            "field4": "gr.400",
                            "description": "biscotti divella vari tipi gr.400",
                            "grammage": null,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.193060123023447,
                                "left": 4.293893129770993,
                                "width": 18.96469465648855,
                                "height": 15.974304798255181
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/25_4HY23XY_MNdPeV8.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_VHyUE6C_LRIedPx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm74368530",
                            "field1": "oro ciok",
                            "field2": "saiwa",
                            "field3": "vari tipi x8",
                            "field4": "",
                            "description": "oro ciok saiwa vari tipi x8",
                            "grammage": null,
                            "price": "1.95",
                            "price_label": "€ 1,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Snack",
                            "blueprint": {
                                "top": 46.16736492127862,
                                "left": 4.293893129770993,
                                "width": 18.96469465648855,
                                "height": 15.7187159214831
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/28_GQ3jkNi_tYLrKKX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_EbYcp7b_B7ggPf3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm02474164",
                            "field1": "girella cacao",
                            "field2": "motta",
                            "field3": "x8",
                            "field4": "",
                            "description": "girella cacao motta x8",
                            "grammage": null,
                            "price": "1.98",
                            "price_label": "€ 1,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Snack",
                            "blueprint": {
                                "top": 46.16736492127862,
                                "left": 23.258587786259543,
                                "width": 18.12977099236641,
                                "height": 15.7187159214831
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/29_Bee2gfF_6rhPYpX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_NRSu0dp_ZgTDd15.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm97059646",
                            "field1": "brioss",
                            "field2": "kinder ferrero",
                            "field3": "x10",
                            "field4": "",
                            "description": "brioss kinder ferrero x10",
                            "grammage": null,
                            "price": "1.98",
                            "price_label": "€ 1,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 46.16736492127862,
                                "left": 41.38835877862596,
                                "width": 17.891221374045802,
                                "height": 15.7187159214831
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/30_F1yLLN6_5lHaoJI.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_F8E09iJ_AdIVhGO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Kinder_Fetta_al_Latte_-_spot_20_sec..mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66233552",
                            "field1": "fette biscottate",
                            "field2": "grissin bon",
                            "field3": "32 fette",
                            "field4": "",
                            "description": "fette biscottate grissin bon 32 fette",
                            "grammage": null,
                            "price": "0.90",
                            "price_label": "€ 0,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 46.16736492127862,
                                "left": 59.279580152671755,
                                "width": 18.010496183206108,
                                "height": 15.7187159214831
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/31_zl8lSCY_ooXIv2e.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_KwpU2Jz_R9JLFla.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm54302438",
                            "field1": "zucchero",
                            "field2": "zefiro",
                            "field3": "eridania",
                            "field4": "kg.1",
                            "description": "zucchero zefiro eridania kg.1",
                            "grammage": null,
                            "price": "1.48",
                            "price_label": "€ 1,48",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 46.16736492127862,
                                "left": 77.29007633587787,
                                "width": 17.891221374045802,
                                "height": 15.7187159214831
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/32_3lPpI9l_hoRlQxW.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_qXmp3OA_E2xu4P8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm33462382",
                            "field1": "capsule caffè",
                            "field2": "lavazza",
                            "field3": "vari tipi x16",
                            "field4": "",
                            "description": "capsule caffè lavazza vari tipi x16",
                            "grammage": null,
                            "price": "4.35",
                            "price_label": "€ 4,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 62.39725859630589,
                                "left": 5.12881679389313,
                                "width": 17.891221374045802,
                                "height": 15.7187159214831
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/37_suYUqo0.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_08o2l1K_gXfLmMb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm96044974",
                            "field1": "caffè",
                            "field2": "kosè",
                            "field3": "rosso armonioso",
                            "field4": "gr.250",
                            "description": "caffè kosè rosso armonioso gr.250",
                            "grammage": null,
                            "price": "1.40",
                            "price_label": "€ 1,40",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 62.39725859630589,
                                "left": 23.139312977099237,
                                "width": 18.010496183206108,
                                "height": 15.7187159214831
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/38_3VWmAcV.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_wLdD2Qu_zb8UkpZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm63294647",
                            "field1": "caffè gusto classico",
                            "field2": "lavazza",
                            "field3": "gr.250x2",
                            "field4": "",
                            "description": "caffè gusto classico lavazza gr.250x2",
                            "grammage": null,
                            "price": "3.60",
                            "price_label": "€ 3,60",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 78.11597451778898,
                                "left": 4.770992366412214,
                                "width": 36.37881679389313,
                                "height": 16.996660305343514
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/39_snkm32R.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_Yls1eQW_4uruaWV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm40548407",
                            "field1": "biscotti cioccograno",
                            "field2": "mulino bianco",
                            "field3": "gr.330",
                            "field4": "",
                            "description": "biscotti cioccograno mulino bianco gr.330",
                            "grammage": null,
                            "price": "1.75",
                            "price_label": "€ 1,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 83.61113536838876,
                                "left": 83.3264998807252,
                                "width": 11.211832061068703,
                                "height": 9.967966194111234
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/42_f0zaFVh.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_4Dsknxy_K7A0huc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99804373",
                            "field1": "cornetti",
                            "field2": "mulino bianco",
                            "field3": "integrali frutti bosco x6",
                            "field4": "",
                            "description": "cornetti mulino bianco integrali frutti bosco x6",
                            "grammage": null,
                            "price": "2.20",
                            "price_label": "€ 2,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 74.53773024297982,
                                "left": 83.3264998807252,
                                "width": 11.211832061068703,
                                "height": 9.073405125408943
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/41_7gOttjQ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_A3adO2g_mbFhxfz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm14491771",
                            "field1": "cornetti classici",
                            "field2": "mulino bianco",
                            "field3": "x6",
                            "field4": "",
                            "description": "cornetti classici mulino bianco x6",
                            "grammage": null,
                            "price": "1.45",
                            "price_label": "€ 1,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 62.78064191146401,
                                "left": 83.3264998807252,
                                "width": 11.211832061068703,
                                "height": 11.757088331515812
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/40_a8g4Cv6.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_vCDMt6R_8wHOc2i.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.mulinobianco.it/cornetti-classici?gclid=Cj0KCQiAhP2BBhDdARIsAJEzXlENaVI4hCpxUlEADSrtQjkHTbEutmWmGs__hioMDyOdcp7kRFFrjCwaAg5EEALw_wcB&gclsrc=aw.ds"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm24498492",
                            "field1": "nesquik",
                            "field2": "",
                            "field3": "barattolo",
                            "field4": "",
                            "description": "nesquik barattolo",
                            "grammage": null,
                            "price": "2.10",
                            "price_label": "€ 2,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 34.15468771299073,
                                "left": 84.04214873568704,
                                "width": 11.211832061068703,
                                "height": 11.757088331515812
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/36_3jbTHsu_gUZvGix.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_6IDbYfo_rwfQ8Sp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm18703304",
                            "field1": "duo",
                            "field2": "nesquik",
                            "field3": "",
                            "field4": "",
                            "description": "duo nesquik",
                            "grammage": null,
                            "price": "2.70",
                            "price_label": "€ 2,70",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 29.17070461593511,
                                "left": 76.28928614026718,
                                "width": 7.752862595419848,
                                "height": 16.741071428571427
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/35_dGQd4qW_qRPqqti.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_faPuNuz_X5JKxcK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm70266875",
                            "field1": "choco waves",
                            "field2": "nesquik",
                            "field3": "",
                            "field4": "",
                            "description": "choco waves nesquik",
                            "grammage": null,
                            "price": "2.50",
                            "price_label": "€ 2,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 14.47434420154035,
                                "left": 76.28928614026718,
                                "width": 9.422709923664122,
                                "height": 14.696360414394768
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/33_o8BlQ1u_2t3Td4o.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_SpGQ5lt_3Q8VpIn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm32706391",
                            "field1": "palline",
                            "field2": "nesquik",
                            "field3": "",
                            "field4": "",
                            "description": "palline nesquik",
                            "grammage": null,
                            "price": "2.50",
                            "price_label": "€ 2,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 14.857727516698473,
                                "left": 85.95054568225191,
                                "width": 9.422709923664122,
                                "height": 17.12445474372955
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/34_NTaD7KB_QPiC62Z.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_UyznhbY_G0TLxm1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 12,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_12_DQJO9nc.jpg",
                    "products": [
                        {
                            "item_id": "cstm44219274",
                            "field1": "mozzarella",
                            "field2": "crai",
                            "field3": "bio",
                            "field4": "gr.100",
                            "description": "mozzarella crai bio gr.100",
                            "grammage": null,
                            "price": "1.20",
                            "price_label": "€ 1,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 33.51571552106053,
                                "left": 4.962950262404581,
                                "width": 30.05725190839695,
                                "height": 19.808137949836425
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/1_Gg5g7hS_zRSE1l5.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_tG8sQq7_K1i7jL4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm92120804",
                            "field1": "crescenza",
                            "field2": "crai bio",
                            "field3": "gr.100",
                            "field4": "",
                            "description": "crescenza crai bio gr.100",
                            "grammage": null,
                            "price": "1.20",
                            "price_label": "€ 1,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 33.51571552106053,
                                "left": 35.02020217080153,
                                "width": 30.176526717557252,
                                "height": 19.808137949836425
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/2_KcvVcpj_d0u8SHN.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_dz5eVIN_3uH5EGm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm83892188",
                            "field1": "burro",
                            "field2": "crai bio",
                            "field3": "gr.200",
                            "field4": "",
                            "description": "burro crai bio gr.200",
                            "grammage": null,
                            "price": "2.15",
                            "price_label": "€ 2,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 33.51571552106053,
                                "left": 65.19672888835879,
                                "width": 30.509377981870234,
                                "height": 19.808137949836425
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/3_T2usxuo_w3hTmds.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_bBrT0xe_bjlYSMD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99980006",
                            "field1": "aceto di mele",
                            "field2": "crai bio",
                            "field3": "cl.50",
                            "field4": "",
                            "description": "aceto di mele crai bio cl.50",
                            "grammage": null,
                            "price": "1.50",
                            "price_label": "€ 1,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 53.32385347089694,
                                "left": 65.19672888835879,
                                "width": 30.509377981870234,
                                "height": 20.574904580152673
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/6_68jxn9Y_3FERznS.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_3WwuQRO_vzGkJxH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm82193223",
                            "field1": "olio extra vergine",
                            "field2": "crai bio",
                            "field3": "cl.75",
                            "field4": "",
                            "description": "olio extra vergine crai bio cl.75",
                            "grammage": null,
                            "price": "5.80",
                            "price_label": "€ 5,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 53.32385347089694,
                                "left": 35.2337786259542,
                                "width": 29.96295026240458,
                                "height": 20.574904580152673
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/5_e1BIjlj_TKquS7g.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_4B1WRE6_ezQi6Yh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm10549631",
                            "field1": "passata di pomodoro",
                            "field2": "crai bio",
                            "field3": "gr.700",
                            "field4": "",
                            "description": "passata di pomodoro crai bio gr.700",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 53.32385347089694,
                                "left": 4.247301407442748,
                                "width": 30.98647721851145,
                                "height": 20.574904580152673
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/4_pOt2UFM_GiBLWq9.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_NDXP59T_bIjsXYb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm32119196",
                            "field1": "pasta integrale",
                            "field2": "crai bio",
                            "field3": "varie trafile",
                            "field4": "gr.500",
                            "description": "pasta integrale crai bio varie trafile gr.500",
                            "grammage": null,
                            "price": "0.80",
                            "price_label": "€ 0,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 73.89875805104963,
                                "left": 4.247301407442748,
                                "width": 30.98647721851145,
                                "height": 20.830493456924756
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/7_oEQP8OJ_Bc8kXps.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/8_ZXdbD5h_Bien0Mc.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_OsOEAqH_fQjAfbl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm34792716",
                            "field1": "riso arborio",
                            "field2": "crai bio",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "riso arborio crai bio kg.1",
                            "grammage": null,
                            "price": "2.90",
                            "price_label": "€ 2,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.89875805104963,
                                "left": 35.2337786259542,
                                "width": 29.84367545324428,
                                "height": 20.830493456924756
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/9_O3Rk7ma_X0bvmJd.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_611ljkL_K61YNan.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm27888863",
                            "field1": "legumi",
                            "field2": "crai bio",
                            "field3": "ceci/ fagioli borlotti/ cannellini",
                            "field4": "",
                            "description": "legumi crai bio ceci/ fagioli borlotti/ cannellini",
                            "grammage": null,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Ceci",
                                "Borlotti",
                                "Cannellini"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.89875805104963,
                                "left": 65.07745407919847,
                                "width": 31.10575202767176,
                                "height": 20.830493456924756
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/10_djMxsBE_luvsSwI.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_uEswe8J_M3C4Cuu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 13,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_13_07FIdui.jpg",
                    "products": [
                        {
                            "item_id": "cstm41285356",
                            "field1": "bevanda di riso",
                            "field2": "crai bio",
                            "field3": "lt.1",
                            "field4": "",
                            "description": "bevanda di riso crai bio lt.1",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 18.05258847634951,
                                "left": 5.082225071564885,
                                "width": 29.818702290076338,
                                "height": 19.169165757906217
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/11_c3GLbp4_IUUavRR.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_SQ7MrLU_NMynmm4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm45147978",
                            "field1": "gallette mais mini",
                            "field2": "crai bio",
                            "field3": "gr.150",
                            "field4": "",
                            "description": "gallette mais mini crai bio gr.150",
                            "grammage": null,
                            "price": "0.80",
                            "price_label": "€ 0,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 18.05258847634951,
                                "left": 34.90092736164122,
                                "width": 30.176526717557252,
                                "height": 19.169165757906217
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/12_oBhKmsF_GcvJc4b.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_OpXYbDe_EKCmwbz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm95682922",
                            "field1": "mousse mela",
                            "field2": "crai bio",
                            "field3": "vari tipi",
                            "field4": "gr.100x2",
                            "description": "mousse mela crai bio vari tipi gr.100x2",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 18.05258847634951,
                                "left": 65.07745407919847,
                                "width": 30.05725190839695,
                                "height": 19.169165757906217
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/13_jRSsEOT_1mb7Kx5.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_WRdLrsd_vdMckr9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm93292891",
                            "field1": "petali cereali cacao",
                            "field2": "crai bio",
                            "field3": "gr.375",
                            "field4": "",
                            "description": "petali cereali cacao crai bio gr.375",
                            "grammage": null,
                            "price": "2.30",
                            "price_label": "€ 2,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 37.22175423425572,
                                "left": 65.07745407919847,
                                "width": 30.05725190839695,
                                "height": 19.169165757906217
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/17_pxpi1pi_5VtdmUu.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_3uHMeIa_MuGk4o6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88298783",
                            "field1": "vino bio",
                            "field2": "senatore",
                            "field3": "alaei/ arcano",
                            "field4": "",
                            "description": "vino bio senatore alaei/ arcano",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Alaei",
                                "Arcano"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 56.39091999216194,
                                "left": 65.07745407919847,
                                "width": 30.05725190839695,
                                "height": 38.338331515812435
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/21_dpG5Wip_HpK627w.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/22_l4HTkUK_FFzk7xM.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_f0marSr_ieTHxhd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm85289852",
                            "field1": "zucchero tropical bio",
                            "field2": "eridania",
                            "field3": "gr.500",
                            "field4": "",
                            "description": "zucchero tropical bio eridania gr.500",
                            "grammage": null,
                            "price": "1.80",
                            "price_label": "€ 1,80",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 75.048907996524,
                                "left": 35.139476979961835,
                                "width": 29.937977099236644,
                                "height": 19.68034351145038
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/20_CgBHNvF_O1jTBdY.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_A9VhS8a_TuPMN8w.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm03886499",
                            "field1": "composta",
                            "field2": "crai bio",
                            "field3": "vari gusti",
                            "field4": "gr.240",
                            "description": "composta crai bio vari gusti gr.240",
                            "grammage": null,
                            "price": "1.98",
                            "price_label": "€ 1,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 56.2631255537759,
                                "left": 35.139476979961835,
                                "width": 29.937977099236644,
                                "height": 18.785782442748094
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/18_0vmqJNu_uwmzNCA.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_3v7jc44_MX5Y64c.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm78010235",
                            "field1": "fiocchi di mais",
                            "field2": "crai bio",
                            "field3": "gr.375",
                            "field4": "",
                            "description": "fiocchi di mais crai bio gr.375",
                            "grammage": null,
                            "price": "1.50",
                            "price_label": "€ 1,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 37.60513754941385,
                                "left": 35.139476979961835,
                                "width": 29.937977099236644,
                                "height": 18.65798800436205
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/16_tAZBHZi_Pb1C5Tb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_4hUIPSV_X1dZWvu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99591579",
                            "field1": "biscotti",
                            "field2": "crai bio",
                            "field3": "secchi/ integrali",
                            "field4": "gr.300",
                            "description": "biscotti crai bio secchi/ integrali gr.300",
                            "grammage": null,
                            "price": "1.95",
                            "price_label": "€ 1,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Secchi",
                                "Integrali"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 37.60513754941385,
                                "left": 4.485851025763359,
                                "width": 30.653625954198475,
                                "height": 37.57156488549619
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/14_a2RhDbI_aRsqTSX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/15_d2guWBi_1SrkFX7.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_KbgSaYw_7mKZppC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06579148",
                            "field1": "succhi di frutta",
                            "field2": "crai bio",
                            "field3": "vari gusti",
                            "field4": "ml.200x3",
                            "description": "succhi di frutta crai bio vari gusti ml.200x3",
                            "grammage": null,
                            "price": "1.30",
                            "price_label": "€ 1,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 75.17670243491004,
                                "left": 4.485851025763359,
                                "width": 30.653625954198475,
                                "height": 19.169165757906217
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/19_dMLBKEL_4De3tnp.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_pf7joWc_YzhP2X9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 14,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_14_8cvh7tK.jpg",
                    "products": [
                        {
                            "item_id": "cstm07457532",
                            "field1": "coca cola",
                            "field2": "",
                            "field3": "classico/ zero",
                            "field4": "",
                            "description": "coca cola classico/ zero",
                            "grammage": null,
                            "price": "2.90",
                            "price_label": "€ 2,90",
                            "equivalence": 2,
                            "quantity_step": 2,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classica",
                                "Zero"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 13.963166447996183,
                                "left": 5.320774689885496,
                                "width": 22.423664122137406,
                                "height": 29.392720828789535
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/1_1j5zr9X_omhjUSm.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_JjPPgaK_YSeZT3O.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Coca-Cola_presenta_Come_Mai_Prima_con_George_the_Poet.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84883948",
                            "field1": "birra",
                            "field2": "heineken",
                            "field3": "cl.33x3",
                            "field4": "",
                            "description": "birra heineken cl.33x3",
                            "grammage": null,
                            "price": "2.20",
                            "price_label": "€ 2,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 13.963166447996183,
                                "left": 27.744438812022903,
                                "width": 22.304389312977097,
                                "height": 29.392720828789535
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/2_opfmhsw_2hO7WoX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_3dBshIq_IpaEgWz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Heineken_-_Stanza_della_Birra.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51172929",
                            "field1": "acqua naturale",
                            "field2": "levissima",
                            "field3": "lt.2",
                            "field4": "",
                            "description": "acqua naturale levissima lt.2",
                            "grammage": null,
                            "price": "0.38",
                            "price_label": "€ 0,38",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 13.963166447996183,
                                "left": 50.048828125,
                                "width": 22.42366412213741,
                                "height": 15.20753816793893
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/3_2HKoG0U_PIi2mPA.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_OeXS8iR_5kt2rhr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66509145",
                            "field1": "the",
                            "field2": "san benedetto",
                            "field3": "limone/ pesca",
                            "field4": "lt.1.5",
                            "description": "the san benedetto limone/ pesca lt.1.5",
                            "grammage": null,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Limone",
                                "Pesca"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 12.557427625749728,
                                "left": 72.47249224713741,
                                "width": 23.49713740458015,
                                "height": 16.61327699018539
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/4_r6rP4CH_85wSz1U.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_HRswqyS_Yrm7PKW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm03028196",
                            "field1": "bibite zero",
                            "field2": "san benedetto",
                            "field3": "vari tipi",
                            "field4": "ml.750",
                            "description": "bibite zero san benedetto vari tipi ml.750",
                            "grammage": null,
                            "price": "0.45",
                            "price_label": "€ 0,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 29.17070461593511,
                                "left": 72.47249224713741,
                                "width": 23.49713740458015,
                                "height": 32.459787350054526
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/8_GdedCQA_MBa2opi.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_F7BILBW_6QR0JEi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm78742886",
                            "field1": "bibite",
                            "field2": "crai",
                            "field3": "vari tipi",
                            "field4": "lt.1.5",
                            "description": "bibite crai vari tipi lt.1.5",
                            "grammage": null,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 29.17070461593511,
                                "left": 50.28737774332061,
                                "width": 22.185114503816802,
                                "height": 14.185182660850602
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/5_t3wBnZ5_gGyVFD0.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_na20C19_WNUb9mu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm20274935",
                            "field1": "succhi di frutta",
                            "field2": "crai",
                            "field3": "albicocca/ pera/ pesca",
                            "field4": "lt.1",
                            "description": "succhi di frutta crai albicocca/ pera/ pesca lt.1",
                            "grammage": null,
                            "price": "0.90",
                            "price_label": "€ 0,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Albicocca",
                                "Pera",
                                "Pesca"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 43.355887276785715,
                                "left": 50.28737774332061,
                                "width": 22.185114503816802,
                                "height": 18.019015812431846
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/7_ICjMEcO_9Bg7j29.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_s0W9G0q_ApgwZdK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm18379722",
                            "field1": "succhi di frutta",
                            "field2": "optimum yoga",
                            "field3": "vari gusti",
                            "field4": "ml.125x6",
                            "description": "succhi di frutta optimum yoga vari gusti ml.125x6",
                            "grammage": null,
                            "price": "1.50",
                            "price_label": "€ 1,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 43.355887276785715,
                                "left": 27.863713621183216,
                                "width": 22.4236641221374,
                                "height": 18.019015812431846
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/6_KF7Kbps_VB4J6bI.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_LAaVweP_mxpDaOG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm75699389",
                            "field1": "limè",
                            "field2": "bosco",
                            "field3": "cl.50",
                            "field4": "",
                            "description": "limè bosco cl.50",
                            "grammage": null,
                            "price": "5.40",
                            "price_label": "€ 5,40",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 43.483681715171755,
                                "left": 5.440049499045802,
                                "width": 22.42366412213741,
                                "height": 34.63229280261723
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/9_WhOzy77_P1r4f5Q.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_WnPRkOy_BO7HHdb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm05644358",
                            "field1": "moscato",
                            "field2": "santero",
                            "field3": "con fragola/ pesca",
                            "field4": "cl.75",
                            "description": "moscato santero con fragola/ pesca cl.75",
                            "grammage": null,
                            "price": "3.58",
                            "price_label": "€ 3,58",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fragola",
                                "Pesca"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 61.502697527603594,
                                "left": 27.863713621183216,
                                "width": 22.304389312977094,
                                "height": 16.61327699018539
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/10_PjlKpZS_TkMVhvQ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_dmDSGWc_x4IFxxi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm27896339",
                            "field1": "vino",
                            "field2": "notte rossa",
                            "field3": "vari tipi",
                            "field4": "cl.75",
                            "description": "vino notte rossa vari tipi cl.75",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 61.502697527603594,
                                "left": 50.16810293416031,
                                "width": 22.42366412213741,
                                "height": 16.61327699018539
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/11_EPdzmDn_D1dYTRx.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_3vweI7s_kl5Moe7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm22748298",
                            "field1": "brandy stock",
                            "field2": "original",
                            "field3": "cl.70",
                            "field4": "",
                            "description": "brandy stock original cl.70",
                            "grammage": null,
                            "price": "9.50",
                            "price_label": "€ 9,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 77.98818007940294,
                                "left": 50.048828125,
                                "width": 22.542938931297716,
                                "height": 16.357688113413303
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/14_NFGhti7_p99PKyW.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_a1iP4Rq_j3U37p6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06794475",
                            "field1": "amaro",
                            "field2": "unicum",
                            "field3": "cl.70",
                            "field4": "",
                            "description": "amaro unicum cl.70",
                            "grammage": null,
                            "price": "11.30",
                            "price_label": "€ 11,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 77.98818007940294,
                                "left": 27.625164002862604,
                                "width": 22.4236641221374,
                                "height": 16.357688113413303
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/13_QoFEQUz_bihubJX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_sjCcgIv_BhFPoVj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm94441459",
                            "field1": "prosecco treviso",
                            "field2": "maschio",
                            "field3": "cl.75",
                            "field4": "",
                            "description": "prosecco treviso maschio cl.75",
                            "grammage": null,
                            "price": "4.90",
                            "price_label": "€ 4,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 77.98818007940294,
                                "left": 3.770202170801527,
                                "width": 23.854961832061075,
                                "height": 16.357688113413303
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/12_0Sz3apH_dBJzdl7.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_oOQtVdk_UhLis8s.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 15,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_15_fe2p4GF.jpg",
                    "products": [
                        {
                            "item_id": "cstm32926343",
                            "field1": "ricarica sapone liquido",
                            "field2": "dove",
                            "field3": "ml.500",
                            "field4": "",
                            "description": "ricarica sapone liquido dove ml.500",
                            "grammage": null,
                            "price": "1.30",
                            "price_label": "€ 1,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 11.91845543381952,
                                "left": 4.366576216603053,
                                "width": 18.72614503816794,
                                "height": 41.91657579062159
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/15_LcQIeP3_JNNDdVU.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_bh13qxR_vRdPFK4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09881547",
                            "field1": "dentifricio",
                            "field2": "mentadent p",
                            "field3": "ml.75+25",
                            "field4": "",
                            "description": "dentifricio mentadent p ml.75+25",
                            "grammage": null,
                            "price": "1.30",
                            "price_label": "€ 1,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Orale",
                            "blueprint": {
                                "top": 11.91845543381952,
                                "left": 23.092721254770993,
                                "width": 18.010496183206108,
                                "height": 21.725054525627044
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/16_8wn92Ke_zTcok28.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_sO66Eeb_mhMg09z.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm08902786",
                            "field1": "assorbenti",
                            "field2": "lines seta ultra",
                            "field3": "vari tipi",
                            "field4": "pacco doppio",
                            "description": "assorbenti lines seta ultra vari tipi pacco doppio",
                            "grammage": null,
                            "price": "3.98",
                            "price_label": "€ 3,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 11.91845543381952,
                                "left": 41.1032174379771,
                                "width": 35.663167938931295,
                                "height": 21.725054525627044
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/17_WYUB29J_7ZwCBxW.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_miYCtrj_eRWl764.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84659993",
                            "field1": "detersivo piatti",
                            "field2": "nelsen",
                            "field3": "vari tipi",
                            "field4": "ml.900",
                            "description": "detersivo piatti nelsen vari tipi ml.900",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 11.91845543381952,
                                "left": 76.7663853769084,
                                "width": 20.99236641221374,
                                "height": 41.91657579062159
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/18_OmjBmB3_Qq7ntn9.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_XmuAfgQ_3SjUxe2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm25045730",
                            "field1": "tabs tutto in 1",
                            "field2": "pril",
                            "field3": "8 azioni x 26",
                            "field4": "",
                            "description": "tabs tutto in 1 pril 8 azioni x 26",
                            "grammage": null,
                            "price": "3.29",
                            "price_label": "€ 3,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 33.64350995944657,
                                "left": 58.9944388120229,
                                "width": 17.771946564885496,
                                "height": 20.19152126499455
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/21_PckGUpu_ceAts3l.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_phvB9fT_tOupv9G.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35183152",
                            "field1": "carta igienica",
                            "field2": "rotoloni regina",
                            "field3": "x4",
                            "field4": "",
                            "description": "carta igienica rotoloni regina x4",
                            "grammage": null,
                            "price": "2.45",
                            "price_label": "€ 2,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 33.64350995944657,
                                "left": 41.1032174379771,
                                "width": 17.891221374045802,
                                "height": 20.19152126499455
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/20_ivILBdx_jtsgQv6.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_dyJhQIg_hqn87mf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm94472832",
                            "field1": "crema viso",
                            "field2": "nivea",
                            "field3": "vari tipi",
                            "field4": "ml.50",
                            "description": "crema viso nivea vari tipi ml.50",
                            "grammage": null,
                            "price": "3.75",
                            "price_label": "€ 3,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 33.64350995944657,
                                "left": 23.2119960639313,
                                "width": 17.891221374045802,
                                "height": 20.19152126499455
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/19_SObV2oL_Q3ggZql.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_H3WgB5f_YdY2CyX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80251590",
                            "field1": "fustone lavatrice",
                            "field2": "dash",
                            "field3": "79 misurini",
                            "field4": "",
                            "description": "fustone lavatrice dash 79 misurini",
                            "grammage": null,
                            "price": "10.90",
                            "price_label": "€ 10,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 53.83503122444111,
                                "left": 1.2654311784351144,
                                "width": 21.946564885496183,
                                "height": 41.277603598691385
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/22_C3rGmAW_IXb8Mli.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_YokTz0I_aMrekm2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm62054240",
                            "field1": "ammorbidente concentrato",
                            "field2": "lenor",
                            "field3": "vari tipi -26 lavaggi",
                            "field4": "",
                            "description": "ammorbidente concentrato lenor vari tipi -26 lavaggi",
                            "grammage": null,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 53.83503122444111,
                                "left": 23.211996063931295,
                                "width": 17.7719465648855,
                                "height": 20.44711014176663
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/23_TEClX4l_ymZUju4.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_3IwLscz_gsHNOy6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm29960139",
                            "field1": "lysoform bagno gel/",
                            "field2": "",
                            "field3": "cif gell con candeggina",
                            "field4": "ml.750",
                            "description": "lysoform bagno gel/ cif gell con candeggina ml.750",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Lysoform bagno gel",
                                "Cif gell con candeggina"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 53.83503122444111,
                                "left": 40.9839426288168,
                                "width": 18.12977099236641,
                                "height": 20.44711014176663
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/24_fckqiHI_uHatC4Q.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/25_qO6nMYk_7qGFkPI.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_FFfCwUA_v8pMdKv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm00948976",
                            "field1": "tovaglioli",
                            "field2": "crai",
                            "field3": "decorati -2 veli x50",
                            "field4": "",
                            "description": "tovaglioli crai decorati -2 veli x50",
                            "grammage": null,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 53.83503122444111,
                                "left": 59.11371362118321,
                                "width": 17.891221374045806,
                                "height": 20.44711014176663
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/26_pfSbOAS_vT3GAqT.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_XlndP9P_5A9iysi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm25481218",
                            "field1": "detergente spray",
                            "field2": "ace",
                            "field3": "vari tipi",
                            "field4": "ml.500",
                            "description": "detergente spray ace vari tipi ml.500",
                            "grammage": null,
                            "price": "1.45",
                            "price_label": "€ 1,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 53.83503122444111,
                                "left": 77.00493499522901,
                                "width": 20.515267175572518,
                                "height": 41.533192475463466
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/29_Dd21QXA_7SN0y1s.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_RaxCeGB_HNk6J6b.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm46422498",
                            "field1": "tuttofare",
                            "field2": "scottex",
                            "field3": "x2",
                            "field4": "",
                            "description": "tuttofare scottex x2",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 74.15434692782169,
                                "left": 58.9944388120229,
                                "width": 18.01049618320611,
                                "height": 21.21387677208288
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/28_7LT99ma_PLR8pPd.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_Udv3XP3_J9amfcP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm55853671",
                            "field1": "patè randy dog",
                            "field2": "crai",
                            "field3": "manzo",
                            "field4": "gr.150",
                            "description": "patè randy dog crai manzo gr.150",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 74.15434692782169,
                                "left": 23.092721254770993,
                                "width": 35.901717557251914,
                                "height": 21.21387677208288
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/27_A6oG8z3_K9aVjNx.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_sCSkngy_ra1hf1S.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 16,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/page_16_D9iSSWJ.jpg",
                    "products": [
                        {
                            "item_id": "cstm44417627",
                            "field1": "bieta fogliapiù",
                            "field2": "orogel",
                            "field3": "gr.900",
                            "field4": "",
                            "description": "bieta fogliapiù orogel gr.900",
                            "grammage": null,
                            "price": "2.30",
                            "price_label": "€ 2,30",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 17.28582184603326,
                                "left": 5.678599117366412,
                                "width": 17.771946564885496,
                                "height": 16.741071428571427
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/30_hM7uW8r_3rxKs5E.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_hqZsVBZ_yutPv36.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "bieta",
                                        "testo": "Pratici cubetti porzionati che raccolgono solo le migliori foglie di bieta erbetta. Foglia Più è una novità esclusiva Orogel pensata per mantenere intatte tutte le proprietà nutritive delle tue verdure, senza stress durante la cottura. (Fonte: orogel.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/images/4694_n_Orogel_retail_I-Vegetali-tal-quali_Cubello_bieta-erbetta.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm90108562",
                            "field1": "parmigiano reggiano",
                            "field2": "crai",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "parmigiano reggiano crai gr.250",
                            "grammage": null,
                            "price": "5.50",
                            "price_label": "€ 5,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 17.28582184603326,
                                "left": 23.450545682251906,
                                "width": 17.652671755725194,
                                "height": 16.741071428571427
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/31_kA8vzix_jVtGuFB.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_1LiUpPZ_SlARHPd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm39341523",
                            "field1": "formaggio grattuggiato fresco",
                            "field2": "biraghi",
                            "field3": "gr.100",
                            "field4": "",
                            "description": "formaggio grattuggiato fresco biraghi gr.100",
                            "grammage": null,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 17.28582184603326,
                                "left": 41.1032174379771,
                                "width": 17.771946564885496,
                                "height": 16.741071428571427
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/32_Qmo1aOy_jMscVME.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_XWwHoYX_rwjYlT9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/video/Biraghi.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm83296665",
                            "field1": "yogurt",
                            "field2": "vitasnella",
                            "field3": "vari gusti",
                            "field4": "gr.115x8",
                            "description": "yogurt vitasnella vari gusti gr.115x8",
                            "grammage": null,
                            "price": "2.85",
                            "price_label": "€ 2,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 17.28582184603326,
                                "left": 58.8751640028626,
                                "width": 17.53339694656489,
                                "height": 16.741071428571427
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/33_X84BgQr_ONAiFOe.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_8mISVPP_OloK4eS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm69096312",
                            "field1": "olive verdi intere",
                            "field2": "crai",
                            "field3": "gr.300",
                            "field4": "",
                            "description": "olive verdi intere crai gr.300",
                            "grammage": null,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 17.28582184603326,
                                "left": 76.40856094942748,
                                "width": 17.891221374045802,
                                "height": 16.741071428571427
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/34_RwAgcBs_7xSckZN.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_TfrJs23_2sJJO6y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm44026002",
                            "field1": "alluminio",
                            "field2": "cuki",
                            "field3": "mt.8",
                            "field4": "",
                            "description": "alluminio cuki mt.8",
                            "grammage": null,
                            "price": "1.20",
                            "price_label": "€ 1,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 34.02689327460469,
                                "left": 76.40856094942748,
                                "width": 17.891221374045802,
                                "height": 16.996660305343514
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/39_dOOW3Mf_BCscD53.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_qNdUFP5_YC7DQ4P.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm74290631",
                            "field1": "miele millefiori",
                            "field2": "crai",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "miele millefiori crai kg.1",
                            "grammage": null,
                            "price": "6.50",
                            "price_label": "€ 6,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 34.02689327460469,
                                "left": 58.8751640028626,
                                "width": 17.53339694656489,
                                "height": 16.996660305343514
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/38_vnjl5zT_s3YBj1C.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_Yi2ALCV_CQ2Emgl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88225880",
                            "field1": "pesche sciroppate",
                            "field2": "berni",
                            "field3": "vaso gr.700",
                            "field4": "",
                            "description": "pesche sciroppate berni vaso gr.700",
                            "grammage": null,
                            "price": "1.60",
                            "price_label": "€ 1,60",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 34.02689327460469,
                                "left": 41.1032174379771,
                                "width": 17.771946564885496,
                                "height": 16.996660305343514
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/37_O2nd7cq_egpx8dZ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_96g58ao_UUlYagL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm08566305",
                            "field1": "quadrone variegato",
                            "field2": "gecchele",
                            "field3": "gr.400",
                            "field4": "",
                            "description": "quadrone variegato gecchele gr.400",
                            "grammage": null,
                            "price": "1.70",
                            "price_label": "€ 1,70",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 34.02689327460469,
                                "left": 23.569820491412216,
                                "width": 17.53339694656489,
                                "height": 16.996660305343514
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/36_Rhha6PY_aeOg579.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_qyV5GsV_XturpEh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm07338870",
                            "field1": "bar mix",
                            "field2": "cameo",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "bar mix cameo kg.1",
                            "grammage": null,
                            "price": "4.90",
                            "price_label": "€ 4,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 34.02689327460469,
                                "left": 5.7978739265267185,
                                "width": 17.771946564885496,
                                "height": 16.996660305343514
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/35_mSTwK3p_J8b3TSU.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/products/cropped_image_MgnFyKG_sRZHCg0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 17,
                    "image_file": "https://interattivo.s3.amazonaws.com/cEkRLU0Ph2/pages/Fine-CRAI_CpG16Cz.png",
                    "products": []
                }
            ]
        }
    }

}

const lefletSwitch = () => {
    return leaflets.crai;
}

export const serverResponse = lefletSwitch();
